var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _g8, _g9, _path3, _path4, _path5, _path6, _path7, _g10, _g11, _g12, _g13, _g14, _defs, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2, _polygon, _polygon2, _defs2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03MedicalInsurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 343 342",
    style: {
      enableBackground: "new 0 0 343 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000016033359754166376990000006307514401030647209_);}\r\n\t.st2{fill:url(#SVGID_00000161612015869353576820000013527495477488645004_);}\r\n\t.st3{fill:url(#SVGID_00000088134975048392549150000004162878422457979071_);}\r\n\t.st4{fill:url(#SVGID_00000028296074185026111810000000965942802767684523_);}\r\n\t.st5{fill:url(#SVGID_00000145036695884850764260000009483427808460128680_);}\r\n\t.st6{fill:url(#SVGID_00000097471457184649562270000017751255987883685307_);}\r\n\t.st7{fill:url(#SVGID_00000137126307275848176600000008075146306571940770_);}\r\n\t.st8{opacity:0.2;}\r\n\t.st9{opacity:0;fill:#AFB6E5;}\r\n\t.st10{opacity:4.761905e-02;fill:#ABB2E2;}\r\n\t.st11{opacity:9.523810e-02;fill:#A7ADDF;}\r\n\t.st12{opacity:0.1429;fill:#A3A9DC;}\r\n\t.st13{opacity:0.1905;fill:#9FA4D8;}\r\n\t.st14{opacity:0.2381;fill:#9BA0D5;}\r\n\t.st15{opacity:0.2857;fill:#979BD2;}\r\n\t.st16{opacity:0.3333;fill:#9397CF;}\r\n\t.st17{opacity:0.381;fill:#8F92CC;}\r\n\t.st18{opacity:0.4286;fill:#8B8EC9;}\r\n\t.st19{opacity:0.4762;fill:#8789C6;}\r\n\t.st20{opacity:0.5238;fill:#8385C2;}\r\n\t.st21{opacity:0.5714;fill:#7F80BF;}\r\n\t.st22{opacity:0.619;fill:#7B7CBC;}\r\n\t.st23{opacity:0.6667;fill:#7777B9;}\r\n\t.st24{opacity:0.7143;fill:#7373B6;}\r\n\t.st25{opacity:0.7619;fill:#6F6EB3;}\r\n\t.st26{opacity:0.8095;fill:#6B6AB0;}\r\n\t.st27{opacity:0.8571;fill:#6765AC;}\r\n\t.st28{opacity:0.9048;fill:#6361A9;}\r\n\t.st29{opacity:0.9524;fill:#5F5CA6;}\r\n\t.st30{fill:#5B58A3;}\r\n\t.st31{fill:url(#SVGID_00000100369968445991705380000005900706642275705742_);}\r\n\t.st32{opacity:0.5;}\r\n\t.st33{opacity:0;fill:#FFFFFF;}\r\n\t.st34{opacity:3.125000e-02;fill:#FDFEFF;}\r\n\t.st35{opacity:6.250000e-02;fill:#FCFCFE;}\r\n\t.st36{opacity:9.375000e-02;fill:#FAFBFE;}\r\n\t.st37{opacity:0.125;fill:#F9FAFE;}\r\n\t.st38{opacity:0.1562;fill:#F7F8FD;}\r\n\t.st39{opacity:0.1875;fill:#F6F7FD;}\r\n\t.st40{opacity:0.2188;fill:#F4F5FD;}\r\n\t.st41{opacity:0.25;fill:#F3F4FC;}\r\n\t.st42{opacity:0.2812;fill:#F1F3FC;}\r\n\t.st43{opacity:0.3125;fill:#F0F1FC;}\r\n\t.st44{opacity:0.3438;fill:#EEF0FB;}\r\n\t.st45{opacity:0.375;fill:#EDEFFB;}\r\n\t.st46{opacity:0.4062;fill:#EBEDFB;}\r\n\t.st47{opacity:0.4375;fill:#EAECFA;}\r\n\t.st48{opacity:0.4688;fill:#E8EAFA;}\r\n\t.st49{opacity:0.5;fill:#E7E9FA;}\r\n\t.st50{opacity:0.5312;fill:#E5E8F9;}\r\n\t.st51{opacity:0.5625;fill:#E3E6F9;}\r\n\t.st52{opacity:0.5938;fill:#E2E5F8;}\r\n\t.st53{opacity:0.625;fill:#E0E3F8;}\r\n\t.st54{opacity:0.6562;fill:#DFE2F8;}\r\n\t.st55{opacity:0.6875;fill:#DDE1F7;}\r\n\t.st56{opacity:0.7188;fill:#DCDFF7;}\r\n\t.st57{opacity:0.75;fill:#DADEF7;}\r\n\t.st58{opacity:0.7812;fill:#D9DDF6;}\r\n\t.st59{opacity:0.8125;fill:#D7DBF6;}\r\n\t.st60{opacity:0.8438;fill:#D6DAF6;}\r\n\t.st61{opacity:0.875;fill:#D4D9F5;}\r\n\t.st62{opacity:0.9062;fill:#D3D7F5;}\r\n\t.st63{opacity:0.9375;fill:#D1D6F5;}\r\n\t.st64{opacity:0.9688;fill:#D0D4F4;}\r\n\t.st65{fill:#CED3F4;}\r\n\t.st66{fill:url(#SVGID_00000121970238112812120810000009325916035687660458_);}\r\n\t.st67{fill:url(#SVGID_00000138554398010071493300000012931970315105556398_);}\r\n\t.st68{fill:url(#SVGID_00000141442063925482528140000007526697397115797182_);}\r\n\t.st69{opacity:0.8;fill:url(#SVGID_00000160185342787478569370000016868720593481063604_);}\r\n\t.st70{opacity:0.8;fill:url(#SVGID_00000152978162527216256470000005715258761114630322_);}\r\n\t.st71{fill:url(#SVGID_00000101808278935999817070000010460782407134926985_);}\r\n\t.st72{fill:url(#SVGID_00000009556605047016903810000001850233621381561507_);}\r\n\t.st73{fill:url(#SVGID_00000036228518129678409980000010055691612104229309_);}\r\n\t.st74{fill:#7982BD;}\r\n\t.st75{fill:#878FC9;}\r\n\t.st76{opacity:0.15;fill:#FFFFFF;}\r\n\t.st77{opacity:0.3;fill:#FFFFFF;}\r\n\t.st78{fill:url(#SVGID_00000121992823713099298350000015718324450382387587_);}\r\n\t.st79{fill:url(#SVGID_00000130645126926527498060000001836012479336613042_);}\r\n\t.st80{opacity:0.5;fill:url(#SVGID_00000150075218260094158440000004095832799040778684_);}\r\n\t.st81{fill:url(#SVGID_00000001661971481592572390000009937826369083673011_);}\r\n\t.st82{opacity:0.5;fill:url(#SVGID_00000030453559943772683600000008589248576163634619_);}\r\n\t.st83{fill:url(#SVGID_00000036244163848433968590000015548887508611528103_);}\r\n\t.st84{fill:url(#SVGID_00000137100076232001383800000016527370361673539982_);}\r\n\t.st85{opacity:0.5;fill:url(#SVGID_00000140736946541991841250000013048460532399239350_);}\r\n\t.st86{fill:#AFB6E5;}\r\n\t.st87{fill:#9BA3DB;}\r\n\t.st88{fill:url(#SVGID_00000075873923579991168370000007300224919635477172_);}\r\n\t.st89{fill:url(#SVGID_00000088134254453768243280000008978573670722657967_);}\r\n\t.st90{fill:url(#SVGID_00000183244886741516159380000006503888282138645389_);}\r\n\t.st91{fill:url(#SVGID_00000011716172081309867770000005744093186929295544_);}\r\n\t.st92{fill:url(#SVGID_00000050621024761427312920000010934068759412172724_);}\r\n\t.st93{fill:url(#SVGID_00000143588942725725530720000013133094580540211364_);}\r\n\t.st94{fill:url(#SVGID_00000071559740218536868670000008316275311219709078_);}\r\n\t.st95{fill:url(#SVGID_00000097482601281350492560000009194044348080947357_);}\r\n\t.st96{fill:url(#SVGID_00000000900772576495473340000009335105666067152041_);}\r\n\t.st97{fill:url(#SVGID_00000091737107561270693860000000495208105230467478_);}\r\n\t.st98{fill:url(#SVGID_00000150788681128276460420000013509672417478481548_);}\r\n\t.st99{fill:url(#SVGID_00000106115352894712995590000006834048876234733227_);}\r\n\t.st100{fill:url(#SVGID_00000090283140684682849040000012829772244409875348_);}\r\n\t.st101{fill:url(#SVGID_00000065784256333996850810000011213997335708575663_);}\r\n\t.st102{fill:url(#SVGID_00000111877443550547137540000014185361361213959083_);}\r\n\t.st103{fill:url(#SVGID_00000028296788024368635000000011649652618161177765_);}\r\n\t.st104{fill:url(#SVGID_00000027583948322357583740000009795994061015930533_);}\r\n\t.st105{fill:url(#SVGID_00000172426809941863085770000015430384929319328180_);}\r\n\t.st106{fill:url(#SVGID_00000070108312626737791090000015130386964631214741_);}\r\n\t.st107{fill:url(#SVGID_00000083059543031808239480000006548296709443196832_);}\r\n\t.st108{fill:url(#SVGID_00000134939207066175865730000009813032834182227872_);}\r\n\t.st109{fill:url(#SVGID_00000166664155105415101460000012273927333296795012_);}\r\n\t.st110{fill:url(#SVGID_00000101803583274395925570000011671902911652051342_);}\r\n\t.st111{fill:url(#SVGID_00000096752259550285297670000000410224193163361210_);}\r\n\t.st112{fill:url(#SVGID_00000017508415987272913190000012887334550547756199_);}\r\n\t.st113{fill:#E6E7E8;}\r\n\t.st114{fill:#8D97D6;}\r\n\t.st115{fill:url(#SVGID_00000039095195630312984470000005446860756657347970_);}\r\n\t.st116{fill:url(#SVGID_00000093862300738398993950000014869503066374736530_);}\r\n\t.st117{fill:url(#SVGID_00000059308878207557549280000004587740296468807054_);}\r\n\t.st118{fill:url(#SVGID_00000044179990065330472500000014974644277872741514_);}\r\n\t.st119{fill:url(#SVGID_00000107584231338600898090000003818024223436726417_);}\r\n\t.st120{fill:url(#SVGID_00000025423675989449382200000000874972053858655935_);}\r\n\t.st121{fill:url(#SVGID_00000090992029002116610810000008882685964920874680_);}\r\n\t.st122{fill:url(#SVGID_00000181080585733166763040000015939050149265545117_);}\r\n\t.st123{fill:url(#SVGID_00000158746017365142247540000010338127926183854518_);}\r\n\t.st124{fill:url(#SVGID_00000165952138242460435910000012444666836596447890_);}\r\n\t.st125{fill:url(#SVGID_00000140695895831428991850000003515297331860742536_);}\r\n\t.st126{fill:url(#SVGID_00000007423203422260435680000009440812470572742553_);}\r\n\t.st127{fill:url(#SVGID_00000030482186246466754120000017019093076048817299_);}\r\n\t.st128{fill:url(#SVGID_00000047026780871873511440000011799135114573142699_);}\r\n\t.st129{fill:url(#SVGID_00000137819041833862067450000005548636326232362121_);}\r\n\t.st130{fill:url(#SVGID_00000042696586312409047390000002028323963859516297_);}\r\n\t.st131{fill:url(#SVGID_00000170958320350037419850000015719053631866603907_);}\r\n\t.st132{fill:url(#SVGID_00000083067438077575954430000009216567308638223804_);}\r\n\t.st133{fill:url(#SVGID_00000009588174632254710240000006178484498615663034_);}\r\n\t.st134{fill:url(#SVGID_00000096017518749851761450000005883414206259312062_);}\r\n\t.st135{fill:url(#SVGID_00000101782283781050531900000012570169123407918501_);}\r\n\t.st136{fill:#FFFFFF;}\r\n\t.st137{fill:url(#SVGID_00000091015599827258782880000003176620079560574595_);}\r\n\t.st138{fill:url(#SVGID_00000098938195666585336460000008546625525956487869_);}\r\n\t.st139{fill:url(#SVGID_00000088821046101183776980000000079039782515897245_);}\r\n\t.st140{fill:url(#SVGID_00000054967254573912329200000007286871383816958902_);}\r\n\t.st141{fill:url(#SVGID_00000165929090166612635130000003452144342118954901_);}\r\n\t.st142{fill:url(#SVGID_00000122713525834849536520000007935992732661097150_);}\r\n\t.st143{fill:url(#SVGID_00000140002186922919279770000015788884810095398319_);}\r\n\t.st144{fill:url(#SVGID_00000002356944559016799210000000166167024739830954_);}\r\n\t.st145{fill:url(#SVGID_00000057835419607787169080000005913179579905332395_);}\r\n\t.st146{fill:url(#SVGID_00000103247276454275586450000001636307314941362323_);}\r\n\t.st147{fill:url(#SVGID_00000114780319383972914720000015978947630466642596_);}\r\n\t.st148{fill:url(#SVGID_00000142858893814815733350000014482273997849758096_);}\r\n\t.st149{fill:url(#SVGID_00000107587120721028959510000007114349832749920138_);}\r\n\t.st150{fill:url(#SVGID_00000165943360032364480160000000725333311866558091_);}\r\n\t.st151{fill:url(#SVGID_00000040565974225718629950000015122487947333997456_);}\r\n\t.st152{fill:url(#SVGID_00000068658848136767451540000015125654811870712236_);}\r\n\t.st153{fill:url(#SVGID_00000044163131825478495650000018086382722849680529_);}\r\n\t.st154{fill:url(#SVGID_00000073704884642911898390000003878065452894704034_);}\r\n\t.st155{fill:url(#SVGID_00000033370558440729106640000011134488336870843537_);}\r\n\t.st156{fill:url(#SVGID_00000127040133310548237920000004865991570007351218_);}\r\n\t.st157{fill:url(#SVGID_00000129194377697644853900000011265591755884652715_);}\r\n\t.st158{fill:url(#SVGID_00000081633515448685121670000007401729284030210198_);}\r\n\t.st159{fill:url(#SVGID_00000129894502304013126300000006698973920840618370_);}\r\n\t.st160{fill:url(#SVGID_00000129203822116532883730000009122037756739921081_);}\r\n\t.st161{fill:url(#SVGID_00000003803242320143076770000007734685941660309935_);}\r\n\t.st162{fill:url(#SVGID_00000152985228769486000030000012214456928043110842_);}\r\n\t.st163{fill:url(#SVGID_00000006678927277865877630000017804453006580556952_);}\r\n\t.st164{fill:url(#SVGID_00000015320943290297881630000014886103779389860508_);}\r\n\t.st165{fill:url(#SVGID_00000052792184279744837620000014321670842721745060_);}\r\n\t.st166{fill:url(#SVGID_00000085971246357100157190000007085379428165279905_);}\r\n\t.st167{fill:url(#SVGID_00000032625860478163477450000005398730058662642362_);}\r\n\t.st168{fill:url(#SVGID_00000164482569439187504500000007504554462395582116_);}\r\n\t.st169{fill:url(#SVGID_00000077288554449944838040000013820982147000460991_);}\r\n\t.st170{fill:url(#SVGID_00000116946234500021294040000017911714288658148243_);}\r\n\t.st171{fill:url(#SVGID_00000086686594383395771360000009311732381314717570_);}\r\n\t.st172{fill:url(#SVGID_00000145034542430339544380000009907587631849831866_);}\r\n\t.st173{fill:url(#SVGID_00000159452019448364928290000016141820829749416343_);}\r\n\t.st174{fill:url(#SVGID_00000140711649175611784260000002917165014493363632_);}\r\n\t.st175{fill:url(#SVGID_00000017496827260547265210000014877369219030528958_);}\r\n\t.st176{fill:#273B98;}\r\n\t.st177{opacity:9.090909e-02;fill:#AFB6E5;}\r\n\t.st178{opacity:0.1818;fill:#AFB6E5;}\r\n\t.st179{opacity:0.2727;fill:#AFB6E5;}\r\n\t.st180{opacity:0.3636;fill:#AFB6E5;}\r\n\t.st181{opacity:0.4545;fill:#AFB6E5;}\r\n\t.st182{opacity:0.5455;fill:#AFB6E5;}\r\n\t.st183{opacity:0.6364;fill:#AFB6E5;}\r\n\t.st184{opacity:0.7273;fill:#AFB6E5;}\r\n\t.st185{opacity:0.8182;fill:#AFB6E5;}\r\n\t.st186{opacity:0.9091;fill:#AFB6E5;}\r\n\t.st187{opacity:0.3;}\r\n\t.st188{opacity:9.090909e-02;fill:#A7ADDF;}\r\n\t.st189{opacity:0.1818;fill:#A0A5D9;}\r\n\t.st190{opacity:0.2727;fill:#989CD3;}\r\n\t.st191{opacity:0.3636;fill:#9094CD;}\r\n\t.st192{opacity:0.4545;fill:#898BC7;}\r\n\t.st193{opacity:0.5455;fill:#8183C1;}\r\n\t.st194{opacity:0.6364;fill:#7A7ABB;}\r\n\t.st195{opacity:0.7273;fill:#7272B5;}\r\n\t.st196{opacity:0.8182;fill:#6A69AF;}\r\n\t.st197{opacity:0.9091;fill:#6361A9;}\r\n\t.st198{fill:url(#SVGID_00000150821912209208511380000011670079810908596364_);}\r\n\t.st199{fill:url(#SVGID_00000071549594378252277380000017164571546382378925_);}\r\n\t.st200{fill:url(#SVGID_00000150065574736710615650000007012336771482671236_);}\r\n\t.st201{fill:url(#SVGID_00000055685077964319203900000018040163554883790757_);}\r\n\t.st202{fill:url(#SVGID_00000106118089658983380370000011347263659414693023_);}\r\n\t.st203{fill:url(#SVGID_00000168112535008735674800000012593172912226175422_);}\r\n\t.st204{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st205{fill:url(#SVGID_00000040537098210516777830000001629477907056300179_);}\r\n\t.st206{mask:url(#SVGID_00000140707569600962802260000007962887057496576955_);}\r\n\t.st207{opacity:0.1;fill:#FFFFFF;}\r\n\t.st208{opacity:0.1091;fill:#F8F8FD;}\r\n\t.st209{opacity:0.1182;fill:#F0F2FA;}\r\n\t.st210{opacity:0.1273;fill:#E9EBF8;}\r\n\t.st211{opacity:0.1364;fill:#E2E4F6;}\r\n\t.st212{opacity:0.1455;fill:#DBDEF3;}\r\n\t.st213{opacity:0.1545;fill:#D3D7F1;}\r\n\t.st214{opacity:0.1636;fill:#CCD1EE;}\r\n\t.st215{opacity:0.1727;fill:#C5CAEC;}\r\n\t.st216{opacity:0.1818;fill:#BEC3EA;}\r\n\t.st217{opacity:0.1909;fill:#B6BDE7;}\r\n\t.st218{opacity:0.2;fill:#AFB6E5;}\r\n\t.st219{filter:url(#Adobe_OpacityMaskFilter_00000158718357409365632490000007122871922397688243_);}\r\n\t.st220{fill:url(#SVGID_00000037667749240193139870000002933567968284393382_);}\r\n\t.st221{mask:url(#SVGID_00000108286381620285309070000018204815066989560241_);}\r\n\t.st222{fill:url(#SVGID_00000111898600043437676070000013707925844613662394_);}\r\n\t.st223{opacity:0.1;fill:#5277F7;}\r\n\t.st224{opacity:0.2;fill:#5277F7;}\r\n\t.st225{opacity:0.5;fill:#5277F7;}\r\n\t.st226{opacity:0.15;}\r\n\t.st227{fill:url(#SVGID_00000155856416831528451160000000416398049160476599_);}\r\n\t.st228{fill:url(#SVGID_00000011024755623726322030000012714991616003006382_);}\r\n\t.st229{fill:url(#SVGID_00000085231881956777409080000018441990854492973215_);}\r\n\t.st230{fill:url(#SVGID_00000181073602264864338860000009516660885307730084_);}\r\n\t.st231{fill:url(#SVGID_00000068657389977903704640000001716530901319658162_);}\r\n\t.st232{fill:url(#SVGID_00000016796955527324999970000008183266461562973102_);}\r\n\t.st233{fill:url(#SVGID_00000163754950929324717230000014887603463027188146_);}\r\n\t.st234{fill:url(#SVGID_00000106111085199652698580000016013835206354639039_);}\r\n\t.st235{fill:url(#SVGID_00000125600488229067722860000007488462266600529342_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 4404.1978,
    cy: 4160.4097,
    r: 51.29,
    gradientTransform: "matrix(-1.1516 0.2621 -0.1286 -0.5649 5694.9438 1432.5526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,250.1c-3.6-16,19.8-35,52.5-42.4c32.6-7.4,62-0.5,65.7,15.5c3.6,16-19.8,35-52.5,42.4 C62,273.1,32.6,266.1,29,250.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124133876666704495360000013158597492557564054_",
    cx: 7977.3389,
    cy: 292.9702,
    r: 157.6846,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4314,
    style: {
      stopColor: "#A0AAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8595D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124133876666704495360000013158597492557564054_)"
    },
    d: "M28.5,252.1c-17.5-37,3.7-83.8,47.4-104.4 l0,0c-20,9.4-17.9,56,4.1,105.3C65,251.2,36,250.6,28.5,252.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135661658821900399140000016258159555444815523_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3514,
    y1: 248.0869,
    x2: 60.1014,
    y2: 151.5869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4258BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262973"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135661658821900399140000016258159555444815523_)"
    },
    d: "M30.8,253.9c-0.4,0-0.7-0.2-0.9-0.6 c-0.1-0.2-0.5-1-0.8-1.7l-0.4-0.8c-8.1-17.8-7.7-38.3,1.3-57.7c8.9-19.4,25.2-35.4,46-45.2c0.5-0.2,1.1,0,1.3,0.5 c0.2,0.5,0,1.1-0.5,1.3C35.1,169.4,14.3,214.4,30.5,250l0.4,0.8c0.3,0.7,0.7,1.5,0.8,1.7c0.2,0.5,0,1.1-0.5,1.3 C31.1,253.9,30.9,253.9,30.8,253.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101063074105957296340000010926103741896353941_",
    cx: 7722.792,
    cy: 185.4321,
    r: 178.7779,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4314,
    style: {
      stopColor: "#A0AAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8595D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101063074105957296340000010926103741896353941_)"
    },
    d: "M75.9,147.7 c43.7-20.6,93.3-7.3,110.8,29.7c-8.1,7.8-22.2,21.8-32,40.3C130.5,169.4,95.8,138.3,75.9,147.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057148885076219379870000001309945423714834096_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.2841,
    y1: 169.8032,
    x2: 84.2841,
    y2: 138.0533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4258BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262973"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057148885076219379870000001309945423714834096_)"
    },
    d: "M185.8,180.7c-0.4,0-0.7-0.2-0.9-0.6 c-0.1-0.3-1.1-2.3-1.2-2.6c-17.2-35-65.1-47.5-106.8-27.8c-0.5,0.2-1.1,0-1.3-0.5c-0.2-0.5,0-1.1,0.5-1.3 c20.7-9.8,43.5-12.2,64-6.8c20.6,5.4,36.7,18,45.3,35.5c0.1,0.3,1.1,2.3,1.3,2.6c0.2,0.5,0,1.1-0.5,1.3 C186.1,180.6,185.9,180.7,185.8,180.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094582928930416883420000009580884237999238788_",
    cx: 7556.7856,
    cy: -3002.4946,
    r: 0,
    gradientTransform: "matrix(-0.9041 0.4272 1.8712 3.9599 12526.2119 8809.0088)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF63CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#9F19AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    style: {
      stopColor: "#901BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9857,
    style: {
      stopColor: "#6D23D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B24D6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000094582928930416883420000009580884237999238788_)"
    },
    points: "75.9,147.7 75.9,147.7  75.9,147.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000135657032965521203190000009437140035423447474_",
    cx: 7854.0928,
    cy: 296.1922,
    r: 165.546,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4314,
    style: {
      stopColor: "#A0AAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8595D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135657032965521203190000009437140035423447474_)"
    },
    d: "M75.9,147.7L75.9,147.7 c20-9.4,54.6,21.7,78.7,70C142,219.4,90.7,244.2,80,253C57.9,203.7,55.9,157.1,75.9,147.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143617555039054150910000005366333446728541357_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.845,
    y1: 223.8524,
    x2: 68.8373,
    y2: 150.3389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4258BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262973"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143617555039054150910000005366333446728541357_)"
    },
    d: "M81.4,255.4c-0.4,0-0.7-0.2-0.9-0.6 C58,204.3,56,157.4,76,147.9c9.8-4.6,23.6,0.4,38.8,14.3c14.8,13.5,29.4,33.8,41,57.1c0.2,0.5,0,1.1-0.4,1.3 c-0.5,0.2-1.1,0-1.3-0.4c-23.8-47.7-58.4-79.3-77.2-70.5c-18.8,8.9-16.3,55.7,5.5,104.4c0.2,0.5,0,1.1-0.5,1.3 C81.7,255.4,81.6,255.4,81.4,255.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M230.8,331.2c-2.5,0-4.8-0.6-6.6-1.6l-49.3-29.2l-49.3-29.2c-2.4-1.4-3.8-3.6-3.8-6c0-2.7,1.7-5.2,4.6-6.9 l9.9-6.4c2.3-1.3,5.1-2,8-2c2.5,0,4.8,0.6,6.6,1.6l50.3,29.3l50.3,29.3c2.4,1.4,3.8,3.6,3.8,6c0,2.7-1.7,5.2-4.6,6.9l-11.9,6.1 C236.6,330.5,233.7,331.2,230.8,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M126.5,258.6l6-3.9c0.1,0,3.8-2.5,3.9-2.5c2.3-1.3,5.1-1.9,8-1.9c2.4,0,4.8,0.7,6.5,1.7l50,29.1l50,29.1 c2.1,1.2,3.6,3.3,3.8,5.4c0,0.2,0,0.3,0,0.5c0.1,2.6-1.5,5.1-4.4,6.8l-6.3,3.3c-0.1,0-5.4,2.8-5.5,2.8c-1.8,1-3.9,1.6-6.1,1.8 c-0.6,0.1-1.3,0.1-1.9,0.1c-2.4,0-4.8-0.7-6.5-1.7l-49-28.9l-49-29c-2.2-1.3-3.7-3.4-3.9-5.6c0-0.1,0-0.2,0-0.3 C122,262.8,123.6,260.3,126.5,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.6,258.8l5.9-3.9c0.1-0.1,3.7-2.4,3.9-2.4c2.3-1.2,5.1-1.7,7.9-1.8c2.3,0,4.8,0.8,6.5,1.7l49.7,29 l49.7,29c2,1.2,3.7,3.3,3.9,5.3c0,0.1,0,0.3,0,0.5c0.2,2.6-1.3,5.1-4.2,6.8l-6.2,3.3c-0.1,0.1-5.3,2.7-5.5,2.7 c-1.8,0.9-3.9,1.5-6,1.7c-0.6,0.1-1.3,0-1.9,0c-2.3,0-4.8-0.8-6.5-1.7l-48.6-28.7l-48.7-28.8c-2.1-1.2-3.7-3.4-3.9-5.4 c0-0.1,0-0.2,0-0.3C122.2,263,123.7,260.5,126.6,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.7,259l5.9-3.8c0.2-0.1,3.7-2.3,3.9-2.3c2.3-1.2,5.1-1.6,7.8-1.6c2.2-0.1,4.8,0.9,6.4,1.8l49.3,28.8 l49.3,28.8c1.9,1.1,3.7,3.3,4,5.2c0,0.1,0,0.3,0.1,0.4c0.3,2.5-1.2,5-4.1,6.7l-6.2,3.3c-0.2,0.1-5.2,2.6-5.5,2.6 c-1.8,0.9-3.9,1.3-6,1.5c-0.5,0-1.3,0-1.9,0c-2.2,0-4.8-0.9-6.4-1.8L175.1,300l-48.4-28.6c-2-1.1-3.8-3.4-4-5.3 c0-0.1,0-0.2-0.1-0.3C122.3,263.2,123.8,260.7,126.7,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.8,259.2l5.8-3.8c0.2-0.1,3.6-2.2,3.9-2.3c2.3-1.1,5.1-1.4,7.8-1.5c2-0.1,4.9,1,6.3,1.9l49,28.6l49,28.6 c1.8,1.1,3.8,3.3,4,5.1c0,0.1,0.1,0.3,0.1,0.4c0.4,2.5-1,5-3.9,6.7l-6.1,3.3c-0.3,0.2-5.1,2.5-5.5,2.6c-1.8,0.9-3.9,1.2-6,1.4 c-0.5,0-1.3-0.1-1.8-0.1c-2,0-4.9-1-6.3-1.9l-47.9-28.3l-48.2-28.4c-1.9-1.1-3.8-3.3-4.1-5.2c0-0.1,0-0.2-0.1-0.3 C122.5,263.4,123.9,260.9,126.8,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M126.9,259.4l5.8-3.8c0.3-0.2,3.5-2.2,3.9-2.2c2.3-1.1,5.1-1.2,7.7-1.3c1.9-0.1,4.9,1.1,6.2,1.9l48.7,28.4 l48.7,28.4c1.7,1,3.8,3.3,4.1,5c0,0.1,0.1,0.3,0.1,0.4c0.5,2.4-0.8,4.9-3.7,6.6l-6,3.3c-0.4,0.2-5,2.5-5.4,2.5 c-1.8,0.8-3.9,1.1-5.9,1.2c-0.5,0-1.3-0.1-1.8-0.1c-1.9,0-4.9-1.1-6.2-1.9l-47.6-28.1l-47.9-28.2c-1.7-1-3.9-3.3-4.2-5.1 c0-0.1-0.1-0.2-0.1-0.3C122.7,263.6,124,261.1,126.9,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M127.1,259.6l5.7-3.8c0.3-0.2,3.5-2.1,3.8-2.2c2.3-1.1,5.1-1.1,7.7-1.2c1.8-0.1,4.9,1.2,6.2,2l48.4,28.2 l48.3,28.2c1.6,0.9,3.9,3.3,4.2,4.8c0,0.1,0.1,0.3,0.1,0.4c0.6,2.4-0.7,4.9-3.6,6.6l-6,3.3c-0.4,0.2-4.9,2.4-5.4,2.4 c-1.8,0.8-3.9,1-5.9,1.1c-0.5,0-1.3-0.2-1.8-0.2c-1.8,0-4.9-1.2-6.2-2l-47.2-27.8l-47.6-28c-1.6-0.9-3.9-3.3-4.2-4.9 c0-0.1-0.1-0.2-0.1-0.3C122.8,263.8,124.1,261.3,127.1,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M127.2,259.8l5.7-3.8c0.4-0.2,3.4-2,3.8-2.1c2.3-1,5.1-0.9,7.6-1.1c1.7-0.1,4.9,1.4,6.1,2.1l48,28l48,28 c1.5,0.9,3.9,3.2,4.2,4.7c0,0.1,0.1,0.3,0.1,0.4c0.7,2.3-0.5,4.8-3.4,6.5l-5.9,3.3c-0.5,0.3-4.8,2.3-5.4,2.4 c-1.8,0.7-3.9,0.9-5.9,0.9c-0.4,0-1.3-0.2-1.8-0.2c-1.7,0-4.9-1.4-6.1-2.1l-46.9-27.6l-47.3-27.8c-1.5-0.9-4-3.3-4.3-4.8 c0-0.1-0.1-0.2-0.1-0.3C123,264,124.3,261.5,127.2,259.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M127.3,260l5.6-3.8c0.4-0.2,3.3-2,3.8-2.1c2.3-1,5.1-0.7,7.5-0.9c1.6-0.1,4.9,1.5,6,2.1l47.7,27.8l47.7,27.8 c1.4,0.8,4,3.2,4.3,4.6c0,0.1,0.1,0.3,0.1,0.4c0.8,2.3-0.3,4.8-3.2,6.5l-5.9,3.3c-0.6,0.3-4.7,2.3-5.4,2.3 c-1.9,0.7-3.9,0.8-5.8,0.8c-0.4,0-1.3-0.2-1.7-0.2c-1.6,0-4.9-1.5-6-2.1l-46.5-27.4l-47-27.6c-1.4-0.8-4.3-3.3-4.4-4.7 c0-0.1-0.1-0.2-0.1-0.3C123.2,264.2,124.4,261.7,127.3,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M127.4,260.2l5.6-3.7c0.5-0.3,3.2-1.9,3.8-2c2.3-0.9,5.1-0.6,7.5-0.8c1.4-0.1,4.9,1.6,6,2.2l47.4,27.6 l47.3,27.6c1.3,0.7,4.3,3.2,4.4,4.5c0.1,0.1,0.1,0.2,0.2,0.4c0.9,2.2-0.2,4.7-3.1,6.4l-5.8,3.4c-0.6,0.4-4.6,2.2-5.4,2.2 c-1.9,0.6-3.9,0.7-5.8,0.7c-0.4,0-1.3-0.3-1.7-0.3c-1.4,0-4.9-1.6-6-2.2L175.6,299l-46.7-27.5c-1.3-0.8-4.4-3.3-4.5-4.6 c0-0.1-0.1-0.2-0.1-0.3C123.4,264.4,124.5,261.9,127.4,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M127.5,260.4l5.6-3.7c0.5-0.3,3.2-1.8,3.8-1.9c2.4-0.9,5-0.4,7.4-0.7c1.3-0.1,4.9,1.7,5.9,2.2l47.1,27.4 l47,27.4c1.2,0.7,4.4,3.2,4.4,4.4c0.1,0.1,0.1,0.2,0.2,0.4c1,2.2,0,4.7-2.9,6.4l-5.7,3.4c-0.7,0.4-4.5,2.1-5.3,2.2 c-1.9,0.6-3.9,0.6-5.8,0.5c-0.3,0-1.3-0.3-1.7-0.3c-1.3,0-4.9-1.7-5.9-2.2l-45.9-26.9l-46.4-27.3c-1.2-0.7-4.5-3.3-4.5-4.5 c-0.1-0.1-0.1-0.2-0.2-0.3C123.5,264.6,124.6,262.1,127.5,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M127.6,260.6l5.5-3.7c0.6-0.3,3.1-1.8,3.8-1.9c2.4-0.8,5-0.3,7.4-0.5c1.2-0.1,5,1.8,5.8,2.3l46.7,27.2 l46.7,27.2c1.1,0.6,4.4,3.2,4.5,4.2c0.1,0.1,0.1,0.2,0.2,0.3c1.1,2.1,0.2,4.6-2.8,6.3l-5.7,3.4c-0.8,0.4-4.4,2.1-5.3,2.1 c-1.9,0.6-3.9,0.4-5.7,0.4c-0.3,0-1.3-0.4-1.7-0.4c-1.2,0-5-1.8-5.8-2.3l-45.5-26.7l-46.1-27.1c-1.1-0.6-4.5-3.2-4.6-4.3 c-0.1-0.1-0.1-0.2-0.2-0.3C123.7,264.9,124.7,262.3,127.6,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M127.8,260.8l5.5-3.7c0.6-0.4,3-1.7,3.8-1.8c2.4-0.8,5-0.1,7.3-0.4c1.1-0.1,5,1.9,5.7,2.4l46.4,27.1l46.3,27 c1,0.6,4.5,3.1,4.6,4.1c0.1,0.1,0.1,0.2,0.2,0.3c1.3,2.1,0.4,4.6-2.6,6.3l-5.6,3.4c-0.8,0.5-4.3,2-5.3,2c-1.9,0.5-3.9,0.3-5.7,0.2 c-0.3,0-1.4-0.4-1.6-0.4c-1.1,0-5-1.9-5.7-2.4l-45.2-26.5l-45.8-26.9c-1-0.6-4.6-3.2-4.7-4.2c-0.1-0.1-0.1-0.2-0.2-0.3 C123.9,265.1,124.8,262.5,127.8,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M127.9,261l5.4-3.7c0.7-0.4,3-1.6,3.8-1.8c2.4-0.8,5,0.1,7.2-0.2c0.9-0.1,5,2,5.7,2.4l46.1,26.9l46,26.8 c0.9,0.5,4.6,3.1,4.6,4c0.1,0.1,0.2,0.2,0.2,0.3c1.4,2,0.5,4.5-2.4,6.2l-5.6,3.4c-0.9,0.5-4.2,1.9-5.3,2c-1.9,0.5-3.9,0.2-5.7,0.1 c-0.2,0-1.4-0.5-1.6-0.5c-1,0-5-2-5.7-2.4L176,298.3l-45.5-26.7c-0.9-0.5-4.7-3.2-4.8-4.1c-0.1-0.1-0.1-0.2-0.2-0.3 C124,265.3,124.9,262.7,127.9,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M128,261.2l5.4-3.6c0.7-0.4,2.9-1.6,3.8-1.7c2.4-0.7,5,0.2,7.2-0.1c0.8-0.1,5,2.2,5.6,2.5l45.8,26.7 l45.7,26.6c0.8,0.4,4.7,3.1,4.7,3.9c0.1,0.1,0.2,0.2,0.2,0.3c1.5,2,0.7,4.5-2.3,6.2l-5.5,3.4c-1,0.6-4.1,1.8-5.3,1.9 c-1.9,0.4-3.9,0.4-5.6,0c-0.2,0-1.4-0.5-1.6-0.5c-0.8,0-5-2.2-5.6-2.5L176,298.2l-45.2-26.5c-0.8-0.4-4.8-3.2-4.8-4 c-0.1-0.1-0.1-0.2-0.2-0.2C124.2,265.5,125,262.9,128,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M128.1,261.4l5.3-3.6c0.8-0.5,2.8-1.5,3.8-1.6c2.4-0.7,5,0.4,7.1,0c0.7-0.1,5,2.3,5.5,2.6l45.4,26.5 l45.4,26.4c0.6,0.4,4.7,3.1,4.8,3.8c0.1,0.1,0.2,0.2,0.3,0.3c1.6,1.9,0.9,4.4-2.1,6.1l-5.4,3.4c-1.1,0.6-3.9,1.8-5.2,1.8 c-1.9,0.4-3.9,0.3-5.6-0.2c-0.2,0-1.4-0.6-1.6-0.6c-0.7,0-5-2.3-5.5-2.6L176.1,298l-44.9-26.3c-0.7-0.4-4.9-3.2-4.9-3.9 c-0.1-0.1-0.2-0.2-0.2-0.2C124.4,265.7,125.1,263.1,128.1,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M128.2,261.6l5.3-3.6c0.8-0.5,2.8-1.4,3.8-1.6c2.4-0.6,5-0.6,7.1,0.2c0.6,0,5,2.4,5.4,2.6l45.1,26.3l45,26.2 c0.5,0.3,4.8,3.1,4.9,3.6c0.1,0.1,0.2,0.2,0.3,0.3c1.7,1.9,1,4.4-1.9,6.1l-5.4,3.4c-1.1,0.6-3.8,1.7-5.2,1.8 c-1.9,0.3-3.9,0.2-5.6-0.3c-0.2,0-1.4-0.6-1.5-0.6c-0.6,0-5-2.4-5.5-2.6l-43.8-25.6l-44.7-26.1c-0.5-0.3-4.9-3.2-5-3.7 c-0.1-0.1-0.2-0.2-0.2-0.2C124.6,265.9,125.3,263.4,128.2,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M128.3,261.8l5.2-3.6c0.9-0.5,2.7-1.3,3.8-1.5c2.4-0.6,5-0.5,7,0.3c0.5,0,5,2.5,5.4,2.7l44.8,26.1l44.7,26.1 c0.4,0.2,4.9,3.1,4.9,3.5c0.1,0.1,0.2,0.2,0.3,0.3c1.8,1.8,1.2,4.3-1.8,6l-5.3,3.5c-1.2,0.7-3.7,1.6-5.2,1.7c-2,0.3-4,0.2-5.5-0.5 c-0.1,0-1.4-0.6-1.5-0.6c-0.5,0-5-2.5-5.4-2.7l-43.4-25.4l-44.4-25.9c-0.4-0.3-5-3.2-5.1-3.6c-0.1-0.1-0.2-0.1-0.3-0.2 C124.7,266.1,125.4,263.6,128.3,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M128.5,262l5.2-3.6c0.9-0.5,2.6-1.3,3.8-1.5c2.4-0.5,5-0.4,6.9,0.4c0.4,0,5,2.6,5.3,2.8l44.4,25.9l44.4,25.9 c0.3,0.2,5,3.1,5,3.4c0.1,0.1,0.2,0.2,0.3,0.3c2,1.8,1.4,4.3-1.6,6l-5.2,3.5c-1.3,0.7-3.6,1.6-5.2,1.7c-2,0.3-4,0.1-5.5-0.6 c-0.1,0-1.4-0.7-1.5-0.7c-0.4,0-5.1-2.6-5.3-2.8l-43.1-25.2l-44.1-25.8c-0.3-0.2-5.1-3.2-5.1-3.5c-0.1-0.1-0.2-0.1-0.3-0.2 C124.9,266.3,125.5,263.8,128.5,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M128.6,262.2l5.2-3.5c1-0.6,2.5-1.2,3.8-1.4c2.4-0.5,5-0.3,6.9,0.6c0.2,0,5.1,2.7,5.2,2.8l44.1,25.7l44,25.7 c0.2,0.1,5,3.1,5.1,3.3c0.1,0.1,0.2,0.2,0.3,0.2c2.1,1.7,1.5,4.2-1.4,5.9l-5.2,3.5c-1.3,0.8-3.5,1.5-5.2,1.6c-2,0.2-4,0-5.4-0.7 c-0.1,0-1.4-0.7-1.5-0.7c-0.2,0-5.1-2.7-5.2-2.8l-42.7-25l-43.8-25.6c-0.2-0.1-5.2-3.1-5.2-3.4c-0.1-0.1-0.2-0.1-0.3-0.2 C125.1,266.5,125.6,264,128.6,262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M128.7,262.4l5.1-3.5c1-0.6,2.5-1.1,3.7-1.4c2.4-0.5,5-0.2,6.8,0.7c0.1,0,5.1,2.8,5.2,2.9l43.8,25.5 l43.7,25.5c0.1,0.1,5.1,3,5.1,3.1c0.1,0.1,0.2,0.2,0.3,0.2c2.2,1.6,1.7,4.2-1.3,5.9l-5.1,3.5c-1.4,0.8-3.4,1.4-5.1,1.5 c-2,0.2-4-0.1-5.4-0.9c0,0-1.4-0.8-1.4-0.8c-0.1,0-5.1-2.9-5.2-2.9l-42.4-24.7L133,271.8c-0.1-0.1-5.3-3.1-5.3-3.2 c-0.1-0.1-0.2-0.1-0.3-0.2C125.2,266.7,125.7,264.2,128.7,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M225.2,325.3L176.6,297l-48.6-28.3c-2.7-1.6-2.4-4.3,0.8-6.1l5.1-3.5c3.1-1.8,7.8-2,10.5-0.4l48.6,28.3 l48.6,28.3c2.7,1.6,2.4,4.3-0.8,6.1l-5.1,3.5C232.5,326.7,227.8,326.9,225.2,325.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133516788435413990890000016246879868116815281_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.2708,
    y1: 318.9909,
    x2: 173.3503,
    y2: 283.0778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02214169,
    style: {
      stopColor: "#D3D8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09774044,
    style: {
      stopColor: "#E1E5FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1667,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    style: {
      stopColor: "#E8ECFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#F2F4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133516788435413990890000016246879868116815281_)"
    },
    d: "M224.1,319.5c0-2.2,0.5-4.6,1.4-6.9 l-109.7-62.7l-1.6-0.9c-0.9,2.3-1.4,4.6-1.4,6.8c0,3.8,2.1,6.4,4,7.4l110.2,63.2l-0.2-0.2C225.2,325,224.1,322.7,224.1,319.5z"
  }), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M109.9,246.7c5.8,2.3,8.8,6.1,8.2,9.8c5.6-1.7,12.8-1.6,18.6,0.7c8.4,3.3,10.8,9.7,5.5,14.4 c-9.8,8.6-50.4,8-50.4,8s-16.5-21.7-6.7-30.3C90.4,244.6,101.5,243.5,109.9,246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M109.6,247.1c5.7,2.2,8.6,6,8.1,9.6c5.5-1.7,12.6-1.6,18.3,0.7c8.2,3.2,10.7,9.5,5.4,14.2 c-9.6,8.4-49.6,7.9-49.6,7.9s-16.2-21.4-6.6-29.8C90.5,245.1,101.4,243.9,109.6,247.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M109.4,247.6c5.7,2.2,8.5,5.9,8,9.5c5.4-1.7,12.4-1.6,18,0.6c8.1,3.2,10.5,9.4,5.3,13.9 c-9.5,8.3-48.8,7.8-48.8,7.8s-16-21-6.5-29.3C90.5,245.5,101.3,244.4,109.4,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.1,248c5.6,2.2,8.4,5.8,7.8,9.3c5.4-1.6,12.2-1.5,17.7,0.6c8,3.1,10.3,9.2,5.2,13.7 c-9.3,8.2-48.1,7.7-48.1,7.7s-15.7-20.7-6.4-28.9C90.5,246,101.1,244.9,109.1,248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M108.9,248.4c5.5,2.1,8.2,5.7,7.7,9.2c5.3-1.6,12-1.5,17.5,0.6c7.9,3.1,10.2,9.1,5.1,13.5 c-9.2,8-47.3,7.5-47.3,7.5s-15.5-20.4-6.3-28.4C90.6,246.5,101,245.4,108.9,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M108.6,248.8c5.4,2.1,8.1,5.6,7.6,9c5.2-1.6,11.8-1.5,17.2,0.6c7.7,3,10,9,5.1,13.3 c-9,7.9-46.5,7.4-46.5,7.4s-15.2-20-6.2-28C90.6,246.9,100.9,245.8,108.6,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M108.3,249.3c5.3,2.1,8,5.5,7.5,8.9c5.1-1.6,11.6-1.5,16.9,0.6c7.6,3,9.8,8.8,5,13.1 c-8.9,7.8-45.8,7.3-45.8,7.3s-15-19.7-6.1-27.5C90.7,247.4,100.7,246.3,108.3,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M108.1,249.7c5.2,2,7.8,5.4,7.3,8.7c5-1.5,11.4-1.4,16.6,0.6c7.5,2.9,9.7,8.7,4.9,12.8 c-8.7,7.6-45,7.2-45,7.2s-14.7-19.4-6-27C90.7,247.8,100.6,246.8,108.1,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M107.8,250.1c5.1,2,7.7,5.3,7.2,8.6c4.9-1.5,11.2-1.4,16.3,0.6c7.3,2.9,9.5,8.5,4.8,12.6 c-8.6,7.5-44.2,7-44.2,7s-14.5-19.1-5.9-26.6C90.7,248.3,100.5,247.3,107.8,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M107.6,250.6c5,2,7.6,5.2,7.1,8.4c4.8-1.5,11-1.4,16,0.6c7.2,2.8,9.3,8.4,4.7,12.4 c-8.4,7.4-43.5,6.9-43.5,6.9s-14.2-18.7-5.8-26.1C90.8,248.7,100.4,247.7,107.6,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M107.3,251c4.9,1.9,7.4,5.2,7,8.3c4.8-1.5,10.8-1.4,15.8,0.6c7.1,2.8,9.2,8.2,4.6,12.2 c-8.3,7.3-42.7,6.8-42.7,6.8s-14-18.4-5.7-25.6C90.8,249.2,100.2,248.2,107.3,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M107,251.4c4.9,1.9,7.3,5.1,6.8,8.1c4.7-1.4,10.6-1.3,15.5,0.6c7,2.7,9,8.1,4.6,12 c-8.1,7.1-41.9,6.7-41.9,6.7s-13.7-18.1-5.6-25.2C90.8,249.7,100.1,248.7,107,251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M106.8,251.8c4.8,1.9,7.2,5,6.7,8c4.6-1.4,10.4-1.3,15.2,0.5c6.8,2.7,8.8,7.9,4.5,11.7 c-8,7-41.2,6.6-41.2,6.6s-13.5-17.7-5.5-24.7C90.9,250.1,100,249.2,106.8,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M106.5,252.3c4.7,1.8,7,4.9,6.6,7.8c4.5-1.4,10.2-1.3,14.9,0.5c6.7,2.6,8.7,7.8,4.4,11.5 c-7.8,6.9-40.4,6.4-40.4,6.4s-13.2-17.4-5.4-24.3C90.9,250.6,99.8,249.7,106.5,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M106.3,252.7c4.6,1.8,6.9,4.8,6.5,7.7c4.4-1.4,10-1.3,14.6,0.5c6.6,2.6,8.5,7.6,4.3,11.3 c-7.7,6.7-39.6,6.3-39.6,6.3s-13-17.1-5.3-23.8C91,251,99.7,250.1,106.3,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M106,253.1c4.5,1.8,6.8,4.7,6.3,7.5c4.3-1.3,9.9-1.2,14.3,0.5c6.5,2.5,8.3,7.5,4.2,11.1 c-7.5,6.6-38.9,6.2-38.9,6.2s-12.7-16.7-5.2-23.3C91,251.5,99.6,250.6,106,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M105.8,253.5c4.4,1.7,6.6,4.6,6.2,7.4c4.2-1.3,9.7-1.2,14.1,0.5c6.3,2.5,8.2,7.3,4.1,10.9 c-7.4,6.5-38.1,6.1-38.1,6.1S79.6,262,87,255.5C91,252,99.4,251.1,105.8,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M105.5,254c4.3,1.7,6.5,4.5,6.1,7.2c4.2-1.3,9.5-1.2,13.8,0.5c6.2,2.4,8,7.2,4.1,10.7 c-7.2,6.3-37.3,5.9-37.3,5.9s-12.2-16.1-5-22.4C91.1,252.4,99.3,251.6,105.5,254z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M105.2,254.4c4.2,1.6,6.4,4.4,6,7.1c4.1-1.2,9.3-1.2,13.5,0.5c6.1,2.4,7.9,7,4,10.4 c-7.1,6.2-36.6,5.8-36.6,5.8s-12-15.7-4.9-22C91.1,252.9,99.2,252,105.2,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M105,254.8c4.1,1.6,6.2,4.3,5.8,6.9c4-1.2,9.1-1.1,13.2,0.5c5.9,2.3,7.7,6.9,3.9,10.2 c-6.9,6.1-35.8,5.7-35.8,5.7s-11.7-15.4-4.8-21.5C91.1,253.3,99,252.5,105,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M104.7,255.3c4.1,1.6,6.1,4.2,5.7,6.8c3.9-1.2,8.9-1.1,12.9,0.5c5.8,2.3,7.5,6.7,3.8,10 c-6.8,6-35,5.6-35,5.6s-11.5-15.1-4.7-21C91.2,253.8,98.9,253,104.7,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M104.5,255.7c4,1.5,6,4.1,5.6,6.6c3.8-1.2,8.7-1.1,12.6,0.5c5.7,2.2,7.4,6.6,3.7,9.8 c-6.6,5.8-34.3,5.5-34.3,5.5s-11.2-14.8-4.6-20.6C91.2,254.3,98.8,253.5,104.5,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M104.2,256.1c3.9,1.5,5.8,4,5.5,6.5c3.7-1.1,8.5-1.1,12.4,0.4c5.6,2.2,7.2,6.4,3.6,9.6 c-6.5,5.7-33.5,5.3-33.5,5.3s-11-14.4-4.5-20.1C91.3,254.7,98.6,253.9,104.2,256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M103.9,256.5c3.8,1.5,5.7,4,5.3,6.3c3.6-1.1,8.3-1,12.1,0.4c5.4,2.1,7,6.3,3.6,9.3 c-6.3,5.6-32.7,5.2-32.7,5.2s-10.7-14.1-4.4-19.7C91.3,255.2,98.5,254.4,103.9,256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M103.7,257c3.7,1.4,5.6,3.9,5.2,6.2c3.6-1.1,8.1-1,11.8,0.4c5.3,2.1,6.9,6.1,3.5,9.1c-6.2,5.4-32,5.1-32,5.1 S81.8,264,88,258.6C91.3,255.6,98.4,254.9,103.7,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M103.4,257.4c3.6,1.4,5.4,3.8,5.1,6.1c3.5-1.1,7.9-1,11.5,0.4c5.2,2,6.7,6,3.4,8.9c-6,5.3-31.2,5-31.2,5 S82,264.3,88.1,259C91.4,256.1,98.3,255.4,103.4,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M103.2,257.8c3.5,1.4,5.3,3.7,5,5.9c3.4-1,7.7-1,11.2,0.4c5.1,2,6.5,5.9,3.3,8.7c-5.9,5.2-30.4,4.8-30.4,4.8 s-10-13.1-4.1-18.3C91.4,256.5,98.1,255.8,103.2,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M102.9,258.2c3.4,1.3,5.2,3.6,4.8,5.8c3.3-1,7.5-0.9,10.9,0.4c4.9,1.9,6.4,5.7,3.2,8.5 c-5.7,5-29.7,4.7-29.7,4.7s-9.7-12.8-4-17.8C91.5,257,98,256.3,102.9,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M102.7,258.7c3.3,1.3,5,3.5,4.7,5.6c3.2-1,7.3-0.9,10.7,0.4c4.8,1.9,6.2,5.6,3.1,8.2 c-5.6,4.9-28.9,4.6-28.9,4.6s-9.5-12.4-3.9-17.4C91.5,257.5,97.9,256.8,102.7,258.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M102.4,259.1c3.3,1.3,4.9,3.4,4.6,5.5c3.1-1,7.1-0.9,10.4,0.4c4.7,1.8,6,5.4,3.1,8 c-5.4,4.8-28.1,4.5-28.1,4.5s-9.2-12.1-3.8-16.9C91.5,257.9,97.7,257.3,102.4,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M102.1,259.5c3.2,1.2,4.8,3.3,4.5,5.3c3-0.9,6.9-0.9,10.1,0.4c4.5,1.8,5.9,5.3,3,7.8 c-5.3,4.6-27.3,4.4-27.3,4.4s-9-11.8-3.7-16.4C91.6,258.4,97.6,257.8,102.1,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M101.9,259.9c3.1,1.2,4.6,3.2,4.3,5.2c3-0.9,6.7-0.8,9.8,0.4c4.4,1.7,5.7,5.1,2.9,7.6 c-5.1,4.5-26.6,4.2-26.6,4.2s-8.7-11.5-3.6-16C91.6,258.8,97.5,258.2,101.9,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M101.6,260.4c3,1.2,4.5,3.1,4.2,5c2.9-0.9,6.5-0.8,9.5,0.3c4.3,1.7,5.5,5,2.8,7.4c-5,4.4-25.8,4.1-25.8,4.1 s-8.5-11.1-3.5-15.5C91.6,259.3,97.3,258.7,101.6,260.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151509707701039456990000016787089509433735309_",
    gradientUnits: "userSpaceOnUse",
    x1: 8472.4248,
    y1: 180.207,
    x2: 8421.4541,
    y2: 266.269,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006098567,
    style: {
      stopColor: "#D2D7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03256833,
    style: {
      stopColor: "#E0E4FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0555556,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08208601,
    style: {
      stopColor: "#F2F4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1595,
    style: {
      stopColor: "#EEEFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    style: {
      stopColor: "#C3C8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3213,
    style: {
      stopColor: "#B4BBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3636,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4545,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5556,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7993,
    style: {
      stopColor: "#D5DAF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9262,
    style: {
      stopColor: "#B9C0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFB6E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151509707701039456990000016787089509433735309_)"
    },
    d: "M81.3,185.9c7.3,4.2,13.8,12.4,17.5,21.1 c0.1,0.1,4.2-1.3,5.8-2c3.6-1.5,8.3-0.9,13.4,2.1c11.4,6.6,20.7,22.6,20.7,35.7c0,24-41.1,32.3-41.1,32.3S58.6,223,58.6,199 c0-6.5-2.8-8.6,1-10.7c0.3-0.2,7.8-4.1,8.1-4.3C71.3,182.4,76.1,182.9,81.3,185.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122712174765836853560000013540328582701070491_",
    gradientUnits: "userSpaceOnUse",
    x1: 8481.2842,
    y1: 263.8022,
    x2: 8439.332,
    y2: 204.9897,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#B6BCE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    style: {
      stopColor: "#C8CDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    style: {
      stopColor: "#F5F6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122712174765836853560000013540328582701070491_)"
    },
    d: "M74.4,189.7c8,4.6,14.9,13.8,18.3,23.3 c3.5-5.6,10.4-6.8,18.3-2.2c11.4,6.6,20.7,22.6,20.7,35.7c0,24-39.1,31.1-39.1,31.1s-39.1-52.2-39.1-76.2 C53.7,188.4,62.9,183.1,74.4,189.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110432342657036391520000012811372169280450458_",
    gradientUnits: "userSpaceOnUse",
    x1: 8421.2256,
    y1: 283.4172,
    x2: 8470.8896,
    y2: 192.9763,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    style: {
      stopColor: "#E33D65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3349,
    style: {
      stopColor: "#F2416C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5505,
    style: {
      stopColor: "#FF4572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7007,
    style: {
      stopColor: "#FF5471"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    style: {
      stopColor: "#FF7D6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7E6F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110432342657036391520000012811372169280450458_)"
    },
    d: "M92.7,274c6.9-1.6,36.4-9.4,36.4-29 c0-11.5-8.1-25.5-18.1-31.2c-6.7-3.9-12.9-3.2-16,1.9l-2.3,3.7l-2.3-6.4c-3.1-8.7-9.3-16.5-16-20.4c-10-5.8-18.1-1.1-18.1,10.3 C56.3,222.6,85.8,264.5,92.7,274z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M61.9,191.2c-3.1,2-5,5.9-5,11.4c0,19.6,29.5,61.5,36.4,71.1c3.4-0.8,12.5-3.1,20.7-7.6 c-8.4,4.8-17.8,7.2-21.4,8c-6.9-9.6-36.4-51.4-36.4-71.1C56.3,197.1,58.4,193,61.9,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M95.7,215.3l-2.3,3.7l-0.2-0.5l1.8-2.9c0.9-1.5,2.1-2.6,3.5-3.3C97.4,213.1,96.5,214.1,95.7,215.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000032635933711263103120000010015427477610207129_",
    cx: 8468.8008,
    cy: 200.0474,
    r: 14.9537,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000032635933711263103120000010015427477610207129_)"
    },
    d: "M73.2,190.2 c8,4.6,15.8,13.8,19.3,23.4c0.7-1.1-0.3-0.7,0.7-1.5C89.6,203,83,194.4,75.4,190c-6.3-3.6-11-4.5-14.7-2.2 C64.2,186.8,68.5,187.4,73.2,190.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000135680422722116393130000014781321655555252653_",
    cx: 8430.8662,
    cy: 239.17,
    r: 25.4122,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000135680422722116393130000014781321655555252653_)"
    },
    d: "M111.6,210.8 c-6.2-3.6-11.1-3.7-14.2-1.7c3.5-1,7.8-0.4,12.5,2.3c11.4,6.6,20.7,22.6,20.7,35.7c0,11.1-8.4,18.6-17.5,23.5 c10.1-4.7,19.2-11.7,19.2-24.1C132.3,233.4,123.1,217.4,111.6,210.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000015334759715179656000000003923247427552149135_",
    cx: 8455.5576,
    cy: 217.8284,
    r: 13.5734,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#836DF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    style: {
      stopColor: "#6655BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2347,
    style: {
      stopColor: "#4B3E8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3582,
    style: {
      stopColor: "#342B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4824,
    style: {
      stopColor: "#211C3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    style: {
      stopColor: "#130F23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7347,
    style: {
      stopColor: "#08070F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8641,
    style: {
      stopColor: "#020204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015334759715179656000000003923247427552149135_)"
    },
    d: "M92.7,219.4l2.3-3.7 c2.3-3.8,6.4-5.1,11.1-4L92.7,219.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119839994848741732770000006591437895448139189_",
    cx: 8458.3027,
    cy: 273.8964,
    r: 19.7387,
    gradientTransform: "matrix(-1 0 0 1 8545.7461 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#836DF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    style: {
      stopColor: "#6655BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2347,
    style: {
      stopColor: "#4B3E8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3582,
    style: {
      stopColor: "#342B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4824,
    style: {
      stopColor: "#211C3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    style: {
      stopColor: "#130F23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7347,
    style: {
      stopColor: "#08070F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8641,
    style: {
      stopColor: "#020204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119839994848741732770000006591437895448139189_)"
    },
    d: "M92.6,273.9c-2.6-3.6-8.2-11.5-14.3-21 l41.5,5.4L92.6,273.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035498547826052678110000011655702812588864696_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.7257,
    y1: 220.8036,
    x2: 78.6082,
    y2: 146.5904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFB6E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035498547826052678110000011655702812588864696_)"
    },
    d: "M75.9,147.7 c43.7-20.6,93.3-7.3,110.8,29.7c-4.2,4-9.9,9.6-15.8,16.7c-8.1,0.9-17,3.5-25.5,8.5c-18.9-0.8-58.7,16.9-68.7,32.5 c-26.6-4.6-54.3,0.9-49.9,10.2c-2.4-5.1-3.8-11.1-4.2-17.9C21.1,196.3,41.5,163.9,75.9,147.7z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.8,
    y: 150.8,
    transform: "matrix(0.8999 -0.4361 0.4361 0.8999 -86.9073 71.7891)",
    className: "st74",
    width: 4.2,
    height: 148.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M89.1,178.3c0.3,0,0.6-0.1,0.9-0.2c1.1-0.5,1.5-1.8,1-2.8l-16.1-33.5c-0.5-1.1-1.8-1.5-2.8-1 c-1.1,0.5-1.5,1.8-1,2.8l16.1,33.5C87.5,177.8,88.3,178.3,89.1,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M89.5,176.5c0.1,0,0.2,0,0.3-0.1c0.4-0.2,0.5-0.6,0.4-1L74.1,142c-0.2-0.4-0.6-0.5-1-0.4 c-0.4,0.2-0.5,0.6-0.4,1l16.1,33.5C89,176.4,89.3,176.5,89.5,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M89.7,175.9C89.7,175.9,89.7,175.9,89.7,175.9c0.1-0.1,0.2-0.1,0.1-0.2l-16.1-33.5c0-0.1-0.1-0.1-0.1-0.1 c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2l16.1,33.5C89.6,175.8,89.6,175.9,89.7,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M87.8,177C87.8,177,87.8,177,87.8,177c0.1-0.1,0.2-0.1,0.1-0.2l-16.1-33.5c0-0.1-0.1-0.1-0.1-0.1 c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2l16.1,33.5C87.7,177,87.7,177,87.8,177z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168795674096026907870000004798796446640796312_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.9083,
    y1: 189.6625,
    x2: 75.9083,
    y2: 144.6625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4258BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262973"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168795674096026907870000004798796446640796312_)"
    },
    d: "M64.6,211.4c-0.4,0-0.8-0.3-0.9-0.7 c0-0.1-0.1-0.4-0.2-0.6c-0.3-0.6-0.3-0.8-0.3-1c-5.1-32.7-0.4-55,12.9-61.3c13.3-6.3,33.4,4.2,55.4,28.8c0.1,0.1,0.3,0.4,0.6,1 c0.2,0.3,0.3,0.6,0.4,0.7c0.3,0.4,0.2,1-0.2,1.3c-0.4,0.3-1,0.3-1.3-0.1c-0.1-0.1-0.3-0.4-0.6-0.9c-0.2-0.3-0.3-0.6-0.4-0.7 c-21.3-23.8-40.6-34.1-53.1-28.3C64.3,155.4,60,177,65,208.8c0,0,0.1,0.3,0.2,0.6c0.3,0.6,0.3,0.8,0.3,1c0.1,0.5-0.3,1-0.8,1.1 C64.7,211.4,64.7,211.4,64.6,211.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000166676210565315932890000014257717970130117255_",
    cx: 7891.5498,
    cy: 214.4311,
    r: 123.0559,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72E9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    style: {
      stopColor: "#2AC7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#35B8D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    style: {
      stopColor: "#538FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    style: {
      stopColor: "#5E80F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166676210565315932890000014257717970130117255_)"
    },
    d: "M28.5,252.1c-17.5-37,3.7-83.8,47.4-104.4 l0,0c-13.8,6.5-17.7,30.3-12.6,62.3C38.6,226.2,24.1,242.9,28.5,252.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000182512291592727310030000003492991540939016331_",
    cx: 7992.0396,
    cy: 169.4222,
    r: 57.8885,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#972A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04128253,
    style: {
      stopColor: "#8A266A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    style: {
      stopColor: "#601B4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#3D112F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    style: {
      stopColor: "#220A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    style: {
      stopColor: "#0F040C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    style: {
      stopColor: "#040103"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000182512291592727310030000003492991540939016331_)"
    },
    d: "M27,229.3 c7.6-9.8,19.5-18.9,27.9-24.7c-2.2-15.8-2.2-29.2,0-39.8C34.8,182.2,24.3,206.5,27,229.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080177327918472310510000008402949607422562973_",
    cx: 7903.6328,
    cy: 108.9072,
    r: 104.6883,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72E9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    style: {
      stopColor: "#2AC7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#35B8D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    style: {
      stopColor: "#538FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    style: {
      stopColor: "#5E80F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080177327918472310510000008402949607422562973_)"
    },
    d: "M75.9,147.7 c43.7-20.6,93.3-7.3,110.8,29.7c-4.4-9.3-30.9-13.9-54.6,0.1C110.5,153.2,89.7,141.2,75.9,147.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040557149931492872150000008342318238321555587_",
    cx: 7859.7314,
    cy: 119.8823,
    r: 61.041,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#972A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04128253,
    style: {
      stopColor: "#8A266A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    style: {
      stopColor: "#601B4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#3D112F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    style: {
      stopColor: "#220A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    style: {
      stopColor: "#0F040C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    style: {
      stopColor: "#040103"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000040557149931492872150000008342318238321555587_)"
    },
    d: "M133.3,167.5 c9.6-4.7,20.2-7.3,30.4-7.3c1.7,0,3.4,0.1,5.1,0.2c-12.5-11.9-30.4-18.8-50.5-18.8c-5,0-10.1,0.4-15.1,1.3 C114.2,148.7,124.7,158.3,133.3,167.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000140716318142860143470000005182316512607252410_",
    cx: 7556.9014,
    cy: -2950.1069,
    r: 0,
    gradientTransform: "matrix(-0.9041 0.4272 2.1643 4.5801 13292.9658 10431.166)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF63CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#9F19AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    style: {
      stopColor: "#901BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9857,
    style: {
      stopColor: "#6D23D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B24D6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140716318142860143470000005182316512607252410_)"
    },
    points: "75.9,147.7 75.9,147.7  75.9,147.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090285675914022223250000017521294219218451115_",
    cx: 7542.5898,
    cy: -1625.0505,
    r: 107.5599,
    gradientTransform: "matrix(-0.9041 0.4272 0.4272 0.9041 7594.0283 -1628.6211)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72E9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    style: {
      stopColor: "#2AC7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#35B8D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    style: {
      stopColor: "#538FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    style: {
      stopColor: "#5E80F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090285675914022223250000017521294219218451115_)"
    },
    d: "M75.9,147.7L75.9,147.7 c13.8-6.5,34.6,5.6,56.1,29.8c-18.9-0.8-58.7,16.9-68.7,32.5C58.2,177.9,62.1,154.2,75.9,147.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000064351025853380583830000004620867343026759844_",
    cx: 7896.2822,
    cy: 143.746,
    r: 48.6514,
    gradientTransform: "matrix(-1 0 0 1 8002.9844 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#972A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04128253,
    style: {
      stopColor: "#8A266A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    style: {
      stopColor: "#601B4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#3D112F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    style: {
      stopColor: "#220A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    style: {
      stopColor: "#0F040C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    style: {
      stopColor: "#040103"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000064351025853380583830000004620867343026759844_)"
    },
    d: "M85.8,190.7 c9.2-7.5,24.1-14.1,35.7-16.5c-9.4-9.2-30.4-25.9-36.7-25.9c-1.4,0-2.7,0.3-3.9,0.8C74.8,152.1,80.5,172.4,85.8,190.7z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M272.8,69c-1.5-5.1-5.1-9.9-9-12.2l-5.2-3c-1.8-1.1-2.9-4.1-1.7-5.1c2.1-1.7,3.3-4.8,3.2-8.9 c-0.2-8.4-6-18.5-13.2-23.2c-8.2-5.3-15-1.8-15,7.5c0,3.9,1.2,8.1,3.2,12.1c1.2,2.3,0.1,4.1-1.7,3.1l-5.2-3c-4-2.3-7.5-1.6-9,1.8 l-5.6,12.6L278.4,88L272.8,69z M245.9,37.7c-2.6-1.5-4.8-5.2-4.8-8.2c0-3,2.1-4.2,4.8-2.7c2.6,1.5,4.8,5.2,4.8,8.2 C250.7,38,248.6,39.2,245.9,37.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M242.4,26.5c-1.5,0.1-2.5,1.3-2.5,3.4c0,3,2.1,6.7,4.8,8.2c1.4,0.8,2.7,0.8,3.6,0.2c-0.7,0-1.4-0.2-2.3-0.7 c-2.6-1.5-4.8-5.2-4.8-8.2C241.2,28,241.6,27,242.4,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M245.5,17c7.2,4.6,12.9,14.8,13.2,23.2c0.1,4.2-1.1,7.2-3.2,8.9c-1.2,1-0.1,4,1.7,5.1l5.2,3 c4,2.3,7.5,7.1,9,12.2l5.2,17.6l1.7,1l-5.6-19c-1.5-5.1-5.1-9.9-9-12.2l-5.2-3c-1.8-1.1-2.9-4.1-1.7-5.1c2.1-1.7,3.3-4.8,3.2-8.9 c-0.2-8.4-6-18.5-13.2-23.2c-3.9-2.6-7.6-3.1-10.3-1.9C239.1,14.2,242.2,14.9,245.5,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M226.8,36.6l5.2,3c0.9,0.5,1.5,0.3,1.9-0.2c-0.2,0-0.4-0.1-0.6-0.3l-5.2-3c-2.5-1.5-4.9-1.7-6.7-0.8 C223,35.1,224.8,35.5,226.8,36.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.8,296.1c-2.5,0-4.8-0.6-6.6-1.6l-50-29.3l-50-29.3c-2.4-1.4-3.8-3.6-3.8-6.1c0-2.7,1.7-5.2,4.6-6.9 l1.3-10.7c2.3-1.3,5.1-2,8.1-2c2.5,0,4.8,0.6,6.6,1.6l55.3,31.6l55.3,31.6c2.4,1.4,3.8,3.6,3.8,6.1c0,2.7-1.7,5.2-4.6,6.9 l-11.9,6.1C296.6,295.4,293.7,296.1,290.8,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.4,212.9c2.2-1.3,5.1-2,7.9-2.1c2.5-0.1,4.8,0.5,6.6,1.5c0.1,0,4.7,2.6,4.8,2.7l50.2,28.7l5.5,3.1 l49.5,28.3c2.2,1.3,3.7,3.4,3.9,5.7c0,0.1,0,0.2,0,0.3c0.1,2.6-1.5,5.1-4.4,6.8l-6.7,3.5c-0.1,0-5,2.6-5.1,2.6 c-2.3,1.3-5.1,1.9-8,1.9c-2.4,0-4.8-0.7-6.5-1.7l-49.5-29l-4.4-2.6L185,236.1c-2.3-1.3-3.9-3.6-3.9-5.9c0-2.6,1.3-5.1,4.1-6.7 l0.1-1C185.2,222.3,186.3,213,186.4,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.5,213.6c2.1-1.2,5.1-2,7.8-2.2c2.4-0.1,4.7,0.4,6.6,1.3c0.2,0,4.7,2.5,4.8,2.6l49.9,28.6l5.5,3.1 l49.2,28.2c2.1,1.2,3.8,3.4,4,5.5c0,0.1,0,0.2,0,0.3c0.2,2.6-1.3,5.1-4.2,6.8l-6.6,3.5c-0.1,0.1-4.9,2.5-5.1,2.5 c-2.3,1.2-5.1,1.8-7.9,1.8c-2.3,0-4.8-0.8-6.5-1.7L234.8,265l-4.4-2.6l-44.7-26.2c-2.2-1.3-3.9-3.6-3.9-5.8c0-2.4,0.9-5,3.6-6.6 l0-1C185.1,222.8,186.2,213.8,186.5,213.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.6,214.3c2-1.1,5.1-2,7.6-2.3c2.4-0.2,4.7,0.3,6.5,1.2c0.3,0,4.6,2.4,4.8,2.5l49.6,28.4l5.4,3.1 l48.9,28c2,1.2,3.8,3.4,4,5.4c0,0.1,0,0.2,0,0.3c0.3,2.5-1.1,5.1-4.1,6.7l-6.5,3.5c-0.2,0.1-4.8,2.4-5,2.4 c-2.3,1.2-5.1,1.7-7.8,1.6c-2.2,0-4.8-0.9-6.4-1.8L235,265l-4.3-2.5l-44.3-26c-2.1-1.2-4-3.5-4-5.6c0-2.3,0.6-5,3.1-6.4l0-1 C185,223.3,186.1,214.6,186.6,214.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.6,215c1.9-1.1,5.1-2.1,7.5-2.3c2.4-0.3,4.6,0.2,6.5,1c0.3,0,4.5,2.3,4.8,2.4l49.3,28.3l5.4,3.1 l48.6,27.9c1.9,1.1,3.9,3.4,4.1,5.3c0,0.1,0,0.2,0.1,0.3c0.4,2.5-1,5-3.9,6.7l-6.5,3.5c-0.2,0.1-4.7,2.4-5,2.4 c-2.3,1.1-5,1.6-7.7,1.5c-2,0-4.8-1-6.3-1.8l-48.2-28.2l-4.3-2.5l-43.9-25.7c-2-1.1-4.1-3.5-4.1-5.5c0-2.2,0.2-4.9,2.5-6.2l0-0.9 C185,223.8,186,215.4,186.6,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.7,215.8c1.7-1,5.2-2.1,7.3-2.4c2.3-0.3,4.6,0.1,6.4,0.9c0.4,0,4.5,2.2,4.8,2.3l49,28.1l5.4,3.1 l48.3,27.7c1.8,1,3.9,3.4,4.2,5.2c0,0.1,0,0.2,0.1,0.2c0.6,2.4-0.8,5-3.7,6.7L302,291c-0.3,0.2-4.6,2.3-5,2.3 c-2.3,1.1-5,1.5-7.6,1.3c-1.9,0-4.8-1.1-6.2-1.9l-47.8-27.9l-4.3-2.5l-43.5-25.5c-1.8-1.1-4.2-3.5-4.2-5.3c0-2.1-0.2-4.8,2-6.1 l-0.1-0.9C184.9,224.2,185.9,216.2,186.7,215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M186.7,216.5c1.6-0.9,5.2-2.1,7.2-2.5c2.3-0.4,4.5,0,6.4,0.7c0.5,0,4.4,2.1,4.8,2.3l48.7,28l5.3,3.1 l48,27.6c1.7,1,4,3.4,4.3,5c0,0.1,0.1,0.2,0.1,0.2c0.7,2.4-0.6,4.9-3.6,6.6l-6.3,3.5c-0.4,0.2-4.5,2.2-4.9,2.3 c-2.3,1-5,1.4-7.5,1.2c-1.8,0-4.8-1.2-6.1-1.9l-47.3-27.7l-4.2-2.5l-43.1-25.2c-1.7-1-4.2-3.4-4.2-5.2c0-1.9-0.5-4.7,1.5-5.9 l-0.1-0.9C184.9,224.7,185.8,217,186.7,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M186.8,217.2c1.5-0.9,5.2-2.1,7.1-2.5c2.2-0.5,4.5-0.1,6.4,0.6c0.6,0,4.3,1.9,4.8,2.2l48.4,27.8l5.3,3 l47.7,27.4c1.6,0.9,4,3.4,4.4,4.9c0,0.1,0.1,0.2,0.1,0.2c0.8,2.3-0.4,4.9-3.4,6.6l-6.2,3.5c-0.4,0.2-4.4,2.2-4.9,2.2 c-2.3,1-4.9,1.3-7.4,1c-1.7,0-4.8-1.3-6-2L236,264.7l-4.2-2.4l-42.7-25c-1.6-0.9-4.3-3.4-4.3-5.1c0-1.8-0.9-4.6,1-5.8l-0.2-0.8 C184.8,225.2,185.7,217.8,186.8,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.8,217.9c1.4-0.8,5.2-2.2,6.9-2.6c2.2-0.5,4.4-0.2,6.3,0.4c0.7,0,4.3,1.8,4.8,2.1l48.1,27.7l5.3,3 l47.4,27.3c1.4,0.8,4.4,3.3,4.4,4.8c0,0.1,0.1,0.2,0.1,0.2c0.9,2.3-0.3,4.8-3.2,6.5l-6.1,3.5c-0.5,0.3-4.3,2.1-4.9,2.2 c-2.3,0.9-4.9,1.2-7.3,0.9c-1.6,0-4.8-1.4-5.9-2.1l-46.4-27.1l-4.1-2.4l-42.3-24.7c-1.5-0.9-4.4-3.4-4.4-4.9 c0-1.7-1.3-4.6,0.5-5.6l-0.2-0.8C184.8,225.6,185.6,218.6,186.8,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M186.9,218.6c1.3-0.8,5.2-2.2,6.8-2.7c2.1-0.6,4.4-0.3,6.3,0.3c0.8,0,4.2,1.7,4.8,2l47.8,27.5l5.2,3 l47.2,27.1c1.3,0.8,4.5,3.3,4.5,4.7c0,0.1,0.1,0.1,0.1,0.2c1,2.2-0.1,4.8-3,6.5l-6.1,3.5c-0.6,0.3-4.2,2-4.8,2.1 c-2.3,0.9-4.9,1.2-7.2,0.8c-1.4,0-4.8-1.5-5.9-2.1l-46-26.9l-4.1-2.4l-41.9-24.5c-1.4-0.8-4.4-3.4-4.4-4.8c0-1.5-1.7-4.5,0-5.4 l-0.2-0.8C184.7,226.1,185.5,219.4,186.9,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M186.9,219.3c1.2-0.7,5.2-2.3,6.6-2.7c2.1-0.7,4.3-0.4,6.2,0.1c0.8,0,4.2,1.6,4.8,1.9l47.6,27.4l5.2,3 l46.9,27c1.2,0.7,4.6,3.3,4.6,4.5c0,0.1,0.1,0.1,0.1,0.2c1.1,2.2,0.1,4.7-2.9,6.4l-6,3.5c-0.6,0.4-4,2-4.8,2 c-2.3,0.8-4.9,1.1-7.1,0.6c-1.3,0-4.8-1.6-5.8-2.2l-45.6-26.6l-4.1-2.4L191.2,238c-1.3-0.7-4.5-3.3-4.5-4.6c0-1.4-2-4.4-0.5-5.3 l-0.3-0.7C184.7,226.6,185.4,220.2,186.9,219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M187,220c1.1-0.6,5.2-2.3,6.5-2.8c2-0.7,4.3-0.5,6.2,0c0.9,0,4.1,1.5,4.7,1.9l47.3,27.2l5.2,3l46.6,26.8 c1.1,0.6,4.6,3.3,4.7,4.4c0,0.1,0.1,0.1,0.1,0.2c1.3,2.1,0.3,4.7-2.7,6.4l-5.9,3.5c-0.7,0.4-3.9,1.9-4.8,2c-2.3,0.8-4.8,1-7,0.5 c-1.2,0-4.8-1.7-5.7-2.2l-45.1-26.3l-4-2.3l-41.1-24c-1.2-0.7-4.6-3.3-4.6-4.5c0-1.3-2.4-4.3-1-5.1l-0.3-0.7 C184.6,227,185.4,221,187,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M187,220.7c1-0.6,5.2-2.4,6.4-2.9c1.9-0.8,4.2-0.6,6.2-0.2c1,0,4,1.4,4.7,1.8l47,27l5.1,3l46.3,26.7 c1,0.6,4.7,3.3,4.8,4.3c0,0.1,0.1,0.1,0.1,0.2c1.4,2.1,0.4,4.6-2.5,6.3l-5.8,3.5c-0.7,0.4-3.8,1.8-4.7,1.9 c-2.3,0.7-4.8,0.9-6.9,0.3c-1.1,0-4.8-1.8-5.6-2.3l-44.7-26l-4-2.3l-40.7-23.7c-1-0.6-4.6-3.3-4.6-4.3c0-1.2-2.8-4.2-1.5-5 l-0.4-0.7C184.6,227.5,185.3,221.8,187,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M187.1,221.5c0.9-0.5,5.2-2.5,6.2-3c1.9-0.9,4.2-0.7,6.1-0.3c1.1,0,4,1.2,4.7,1.7l46.7,26.9l5.1,2.9 l46,26.5c0.9,0.5,4.8,3.3,4.8,4.2c0.1,0.1,0.1,0.1,0.2,0.2c1.5,2,0.6,4.6-2.4,6.3l-5.7,3.5c-0.8,0.5-3.7,1.7-4.7,1.9 c-2.3,0.7-4.8,0.8-6.9,0.2c-1,0-4.8-1.9-5.5-2.3l-44.2-25.8l-3.9-2.3l-40.3-23.5c-0.9-0.5-4.7-3.3-4.7-4.2c0-1-3.1-4.2-2-4.8 l-0.4-0.7C184.5,228,185.2,222.6,187.1,221.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M187.2,222.2c0.8-0.4,5.2-2.6,6.1-3c1.8-0.9,4.1-0.8,6.1-0.5c1.2,0,3.9,1.1,4.7,1.6l46.4,26.7l5.1,2.9 l45.7,26.4c0.8,0.4,4.9,3.3,4.9,4c0.1,0.1,0.1,0.1,0.2,0.2c1.6,2,0.8,4.5-2.2,6.2l-5.7,3.5c-0.9,0.5-3.6,1.7-4.7,1.8 c-2.3,0.6-4.7,0.7-6.8,0c-0.8,0-4.8-2.1-5.4-2.4l-43.8-25.5l-3.9-2.3L194,238.8c-0.8-0.5-4.8-3.2-4.8-4.1c0-0.9-3.5-4.1-2.5-4.6 l-0.4-0.6C184.5,228.4,185.1,223.4,187.2,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M187.2,222.9c0.7-0.4,5.2-2.7,5.9-3.1c1.8-1,4.1-0.9,6.1-0.6c1.3,0,3.8,1,4.7,1.5l46.1,26.6l5,2.9 l45.4,26.2c0.7,0.4,5,3.3,5,3.9c0.1,0.1,0.1,0.1,0.2,0.2c1.7,1.9,1,4.5-2,6.2l-5.6,3.5c-0.9,0.5-3.5,1.6-4.6,1.7 c-2.3,0.6-4.7,0.6-6.7-0.1c-0.7,0-4.8-2.2-5.3-2.5l-43.4-25.2l-3.9-2.2l-39.5-23c-0.7-0.4-4.9-3.2-4.9-3.9c0-0.8-3.9-4-3-4.5 l-0.5-0.6C184.4,228.9,185,224.2,187.2,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M187.3,223.6c0.5-0.3,5.1-3.2,5.8-3.2c1.9-0.7,4-1,6-0.8c1.3,0,3.8,0.9,4.7,1.5l45.8,26.4l5,2.9l45.1,26 c0.6,0.3,5.1,3.2,5.1,3.8c0.1,0.1,0.1,0.1,0.2,0.2c1.8,1.9,1.1,4.4-1.9,6.2l-5.5,3.5c-1,0.6-3.4,1.5-4.6,1.7 c-2.3,0.5-4.7,0.5-6.6-0.2c-0.6,0-4.8-2.3-5.3-2.5l-42.9-24.9l-3.8-2.2l-39.1-22.7c-0.6-0.3-4.9-3.2-4.9-3.8 c0-0.6-4.2-3.9-3.5-4.3l-0.5-0.6C184.3,229.4,184.9,225,187.3,223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M187.3,224.3c0.4-0.3,5.1-3.2,5.6-3.2c1.8-0.8,4-1.1,6-0.9c1.4,0,3.7,0.8,4.7,1.4l45.5,26.3l5,2.9 l44.9,25.9c0.4,0.3,5.1,3.2,5.2,3.7c0.1,0.1,0.1,0.1,0.2,0.2c2,1.8,1.3,4.4-1.7,6.1l-5.4,3.5c-1,0.6-3.3,1.5-4.6,1.6 c-2.3,0.5-4.6,0.4-6.5-0.4c-0.5,0-4.8-2.4-5.2-2.6l-42.5-24.7l-3.8-2.2l-38.7-22.5c-0.5-0.3-5-3.2-5-3.6c0-0.5-4.6-3.8-4.1-4.2 l-0.6-0.5C184.3,229.8,184.8,225.8,187.3,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M187.4,225c0.3-0.2,5.1-3.3,5.5-3.3c1.8-0.8,3.9-1.2,5.9-1c1.5,0,3.6,0.7,4.7,1.3l45.2,26.1l4.9,2.9 l44.6,25.7c0.3,0.2,5.2,3.2,5.2,3.5c0.1,0.1,0.1,0.1,0.2,0.2c2.1,1.7,1.5,4.3-1.5,6.1l-5.3,3.5c-1.1,0.6-3.2,1.4-4.5,1.6 c-2.3,0.4-4.6,0.3-6.4-0.5c-0.4,0-4.8-2.5-5.1-2.6l-42-24.4l-3.8-2.2l-38.3-22.2c-0.3-0.2-5.1-3.1-5.1-3.5c0-0.4-5-3.8-4.6-4 l-0.6-0.5C184.2,230.3,184.7,226.6,187.4,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M187.4,225.7c0.2-0.1,5.1-3.4,5.4-3.4c1.7-0.9,3.9-1.3,5.9-1.2c1.6,0,3.6,0.6,4.7,1.2l44.9,26l4.9,2.8 l44.3,25.6c0.2,0.1,5.3,3.2,5.3,3.4c0.1,0.1,0.1,0.1,0.2,0.2c2.2,1.7,1.7,4.3-1.3,6l-5.2,3.5c-1.2,0.7-3.1,1.3-4.5,1.5 c-2.2,0.4-4.6,0.2-6.3-0.7c-0.2,0-4.8-2.6-5-2.7l-41.6-24.1l-3.7-2.2l-37.9-22c-0.2-0.1-5.1-3.1-5.1-3.3c0-0.3-5.4-3.7-5.1-3.8 l-0.7-0.5C184.2,230.8,184.6,227.4,187.4,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M187.5,226.5c0.1-0.1,5.1-3.5,5.2-3.5c1.7-0.9,3.8-1.4,5.9-1.3c1.7,0,3.5,0.4,4.7,1.1l44.6,25.8l4.9,2.8 l44,25.4c0.1,0.1,5.4,3.2,5.4,3.3c0.1,0.1,0.2,0.1,0.2,0.2c2.3,1.6,1.8,4.2-1.2,6l-5.2,3.5c-1.2,0.7-3,1.3-4.5,1.5 c-2.2,0.3-4.6,0.1-6.2-0.8c-0.1,0-4.8-2.7-4.9-2.7l-41.2-23.8l-3.7-2.1L198.2,240c-0.1-0.1-5.2-3.1-5.2-3.2 c0-0.1-5.7-3.6-5.6-3.7l-0.7-0.5C184.1,231.2,184.5,228.2,187.5,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M285.2,290.2L236,261.7l-49.2-28.5c-2.7-1.6-2.4-4.3,0.8-6.1l5.1-3.5c3.1-1.8,7.8-2,10.5-0.4l49.2,28.5 l49.2,28.5c2.7,1.6,2.4,4.3-0.8,6.1l-5.1,3.5C292.6,291.5,287.9,291.7,285.2,290.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946646130768001200000007847133313211590027_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.6183,
    y1: 233.5365,
    x2: 298.3137,
    y2: 84.3816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E62DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#4763E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#5F67E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085946646130768001200000007847133313211590027_)"
    },
    d: "M285.6,289.1l-94.8-54.8 c-7.8-4.5-14.1-16.5-14.1-26.9V37.6c0-10.4,6.3-15.1,14.1-10.6l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9v169.8 C299.7,288.9,293.4,293.6,285.6,289.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018952803357508102800000006465998221613570177_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.6895,
    y1: 11.4428,
    x2: 339.2099,
    y2: 272.9371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361CAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6546,
    style: {
      stopColor: "#393FAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A54AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018952803357508102800000006465998221613570177_)"
    },
    d: "M292.1,78l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.7,3.8-7,4c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9v169.8 c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.9-4.1,7.1-4.3c2.7-1.9,4.3-5.7,4.3-11V104.9 C306.1,94.5,299.8,82.5,292.1,78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157267937223438433370000006635361318957120686_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.3028,
    y1: 25.6912,
    x2: 346.3546,
    y2: 259.4152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#371FAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4953,
    style: {
      stopColor: "#3A38AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#3B41B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7027,
    style: {
      stopColor: "#3B48B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    style: {
      stopColor: "#3C51AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C54AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157267937223438433370000006635361318957120686_)"
    },
    d: "M291.9,78.1l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.6,3.8-6.9,3.9c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.8-4.1,7-4.2c2.7-1.9,4.3-5.7,4.3-11V105 C306,94.6,299.7,82.6,291.9,78.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134950409343469486390000013920424924864146078_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.0042,
    y1: 46.0295,
    x2: 350.0696,
    y2: 244.7055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3723AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#3C37B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#3F42B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#3F48B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    style: {
      stopColor: "#3E51B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E54B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134950409343469486390000013920424924864146078_)"
    },
    d: "M291.8,78.2L197,23.4 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.5,3.7-6.7,3.8c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.7-4,6.9-4.1c2.7-1.9,4.3-5.7,4.3-11V105.1 C305.9,94.7,299.6,82.7,291.8,78.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031904003103304683750000017553168133130329516_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.5281,
    y1: 71.0613,
    x2: 349.7141,
    y2: 229.4354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3826B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3795,
    style: {
      stopColor: "#3D36B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#4244B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    style: {
      stopColor: "#4148B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    style: {
      stopColor: "#4051B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F54B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031904003103304683750000017553168133130329516_)"
    },
    d: "M291.7,78.3l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.3,3.6-6.6,3.8c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.6-3.9,6.7-4c2.7-1.9,4.3-5.7,4.3-11V105.1 C305.8,94.8,299.5,82.7,291.7,78.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079479786807850780600000001283999338855203749_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.853,
    y1: 98.5944,
    x2: 345.3169,
    y2: 214.785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3829B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3549,
    style: {
      stopColor: "#3E36B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#4545B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6763,
    style: {
      stopColor: "#4448B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    style: {
      stopColor: "#4251B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4154B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079479786807850780600000001283999338855203749_)"
    },
    d: "M291.6,78.3l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.2,3.5-6.5,3.7c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.4-3.8,6.6-4c2.7-1.9,4.3-5.7,4.3-11V105.2 C305.7,94.9,299.4,82.8,291.6,78.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130614070334300667350000004130930568464144556_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.1647,
    y1: 118.9885,
    x2: 340.1385,
    y2: 194.593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#392CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3311,
    style: {
      stopColor: "#3F38B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#4847BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    style: {
      stopColor: "#4848BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7972,
    style: {
      stopColor: "#4451B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4354B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130614070334300667350000004130930568464144556_)"
    },
    d: "M291.5,78.4l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6.1,3.4-6.4,3.6c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.3-3.8,6.5-3.9c2.7-1.9,4.3-5.7,4.3-11V105.3 C305.5,94.9,299.2,82.9,291.5,78.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100379633776261913900000013016125893325315237_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.9482,
    y1: 136.7907,
    x2: 329.7495,
    y2: 176.6884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A30B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    style: {
      stopColor: "#423AB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#4C48BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6492,
    style: {
      stopColor: "#4C48BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7912,
    style: {
      stopColor: "#4751B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4554B8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100379633776261913900000013016125893325315237_)"
    },
    d: "M291.4,78.5l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-6,3.4-6.3,3.5c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.2-3.7,6.4-3.8c2.7-1.9,4.3-5.7,4.3-11V105.4 C305.4,95,299.1,83,291.4,78.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183237162037864690490000013805849865171815074_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1678,
    y1: 150.584,
    x2: 315.1103,
    y2: 162.452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A33B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#423CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#4F4AC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    style: {
      stopColor: "#4951BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4754BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183237162037864690490000013805849865171815074_)"
    },
    d: "M291.2,78.6l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.9,3.3-6.2,3.4c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6.1-3.6,6.3-3.7c2.7-1.9,4.3-5.7,4.3-11V105.5 C305.3,95.1,299,83.1,291.2,78.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016790992283973702220000017272537179641957269_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.7503,
    y1: 159.2971,
    x2: 307.9885,
    y2: 152.2542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B36B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    style: {
      stopColor: "#433EBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#524CC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    style: {
      stopColor: "#4B52BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4854BB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016790992283973702220000017272537179641957269_)"
    },
    d: "M291.1,78.6l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.8,3.2-6,3.4c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,6-3.5,6.1-3.6c2.7-1.9,4.3-5.7,4.3-11V105.5 C305.2,95.2,298.9,83.1,291.1,78.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041261546347066099900000017764716110869692339_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.3145,
    y1: 162.1397,
    x2: 312.8828,
    y2: 141.3623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3C3AB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#433FBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#564DC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6492,
    style: {
      stopColor: "#564DC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7912,
    style: {
      stopColor: "#4D52BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A54BD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041261546347066099900000017764716110869692339_)"
    },
    d: "M291,78.7l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.6,3.1-5.9,3.3c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.9-3.4,6-3.6c2.7-1.9,4.3-5.7,4.3-11V105.6 C305.1,95.2,298.8,83.2,291,78.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155109375084773805770000009048398843450449083_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.7133,
    y1: 158.8922,
    x2: 315.1161,
    y2: 129.1845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3C3DBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2447,
    style: {
      stopColor: "#4341BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    style: {
      stopColor: "#564DC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#594FC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    style: {
      stopColor: "#584FC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7972,
    style: {
      stopColor: "#4F53C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C54BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155109375084773805770000009048398843450449083_)"
    },
    d: "M290.9,78.8L196.1,24 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.5,3.1-5.8,3.2c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.7-3.4,5.9-3.5c2.7-1.9,4.3-5.7,4.3-11V105.7 C304.9,95.3,298.7,83.3,290.9,78.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160896875073488553960000003038122928486813322_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.7986,
    y1: 163.2495,
    x2: 314.2832,
    y2: 116.5375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D40BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2299,
    style: {
      stopColor: "#4343BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#554CC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#5C50CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6682,
    style: {
      stopColor: "#5A51CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8025,
    style: {
      stopColor: "#5154C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E55C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160896875073488553960000003038122928486813322_)"
    },
    d: "M290.8,78.9L196,24.1 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.4,3-5.7,3.1c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.6-3.3,5.8-3.4c2.7-1.9,4.3-5.7,4.3-11V105.8 C304.8,95.4,298.5,83.4,290.8,78.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059270436566531017990000001622842655895916722_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.6556,
    y1: 176.4095,
    x2: 310.2925,
    y2: 104.2655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D43BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#4346C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4938,
    style: {
      stopColor: "#534DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#5F52CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6763,
    style: {
      stopColor: "#5C53CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    style: {
      stopColor: "#5354C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5055C3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059270436566531017990000001622842655895916722_)"
    },
    d: "M290.6,79l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.3,2.9-5.6,3.1c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.5-3.2,5.7-3.3c2.7-1.9,4.3-5.7,4.3-11V105.8 C304.7,95.5,298.4,83.4,290.6,79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112592734572244221220000007197496209206258097_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.1458,
    y1: 193.0188,
    x2: 303.4271,
    y2: 93.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E47BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2033,
    style: {
      stopColor: "#4349C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    style: {
      stopColor: "#534EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#6353D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6905,
    style: {
      stopColor: "#5E54CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    style: {
      stopColor: "#5555C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5255C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112592734572244221220000007197496209206258097_)"
    },
    d: "M290.5,79l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5.2,2.8-5.4,3c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.4-3.1,5.6-3.2c2.7-1.9,4.3-5.7,4.3-11V105.9 C304.6,95.6,298.3,83.5,290.5,79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152236801595845069310000005465490325430337409_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.9955,
    y1: 211.5461,
    x2: 294.0272,
    y2: 84.5282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F4ABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    style: {
      stopColor: "#444BC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4321,
    style: {
      stopColor: "#524FC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#6655D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7027,
    style: {
      stopColor: "#5F55CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    style: {
      stopColor: "#5655C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5355C6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152236801595845069310000005465490325430337409_)"
    },
    d: "M290.4,79.1l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-5,2.7-5.3,2.9c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.3-3.1,5.4-3.2c2.7-1.9,4.3-5.7,4.3-11V106 C304.5,95.6,298.2,83.6,290.4,79.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158715658655186184310000016961527246575621001_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.6225,
    y1: 230.1602,
    x2: 284.6415,
    y2: 74.8919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F4DC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    style: {
      stopColor: "#444EC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4081,
    style: {
      stopColor: "#5151CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6358,
    style: {
      stopColor: "#6857D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#6957D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7081,
    style: {
      stopColor: "#6156D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    style: {
      stopColor: "#5855CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5555C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158715658655186184310000016961527246575621001_)"
    },
    d: "M290.3,79.2l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.9,2.7-5.2,2.8c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5.1-3,5.3-3.1c2.7-1.9,4.3-5.7,4.3-11V106.1 C304.4,95.7,298.1,83.7,290.3,79.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048465132800840552230000018432959594311851919_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.9389,
    y1: 246.7038,
    x2: 276.9248,
    y2: 57.2211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4051C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    style: {
      stopColor: "#4452C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    style: {
      stopColor: "#5154CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    style: {
      stopColor: "#6757D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#6D58DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7179,
    style: {
      stopColor: "#6357D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8321,
    style: {
      stopColor: "#5A55CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5755CA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048465132800840552230000018432959594311851919_)"
    },
    d: "M290.2,79.3l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.8,2.6-5.1,2.7c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,5-2.9,5.2-3c2.7-1.9,4.3-5.7,4.3-11V106.2 C304.2,95.8,297.9,83.8,290.2,79.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010309316983605264910000006030309325436643512_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.8855,
    y1: 260.236,
    x2: 264.603,
    y2: 42.3865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4154C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    style: {
      stopColor: "#4555C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3779,
    style: {
      stopColor: "#5156CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#6659D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#705ADD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7224,
    style: {
      stopColor: "#6558D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#5C56CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5955CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010309316983605264910000006030309325436643512_)"
    },
    d: "M290.1,79.4l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.7,2.5-5,2.7c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,4.9-2.8,5.1-2.9c2.7-1.9,4.3-5.7,4.3-11V106.2 C304.1,95.9,297.8,83.8,290.1,79.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018920973651119490220000017406027196632011659_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.4088,
    y1: 269.5681,
    x2: 248.7097,
    y2: 31.5982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4157C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1856,
    style: {
      stopColor: "#4557C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3658,
    style: {
      stopColor: "#5158CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5433,
    style: {
      stopColor: "#645AD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#735BE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    style: {
      stopColor: "#6758D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#5E56D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B55CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018920973651119490220000017406027196632011659_)"
    },
    d: "M289.9,79.4l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.6,2.4-4.8,2.6c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,4.8-2.7,5-2.9c2.7-1.9,4.3-5.7,4.3-11V106.3 C304,96,297.7,83.9,289.9,79.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179631634622584470910000006139155502049462417_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.5137,
    y1: 273.0451,
    x2: 238.9323,
    y2: 24.8626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#425AC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1872,
    style: {
      stopColor: "#465AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    style: {
      stopColor: "#515BCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5261,
    style: {
      stopColor: "#635CD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#765DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#6859D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#5F56D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C55CF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179631634622584470910000006139155502049462417_)"
    },
    d: "M289.8,79.5L195,24.7 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.5,2.4-4.7,2.5c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,4.7-2.7,4.8-2.8c2.7-1.9,4.3-5.7,4.3-11V106.4 C303.9,96,297.6,84,289.8,79.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166641379827990511830000014966966992460603070_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.6965,
    y1: 267.7228,
    x2: 231.7961,
    y2: 20.0393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#425EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    style: {
      stopColor: "#455ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#505ECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5036,
    style: {
      stopColor: "#625ED9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#7A5EE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    style: {
      stopColor: "#795EE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7413,
    style: {
      stopColor: "#6A59D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#6156D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E55D1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166641379827990511830000014966966992460603070_)"
    },
    d: "M289.7,79.6l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.3,2.3-4.6,2.4c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,4.6-2.6,4.7-2.7c2.7-1.9,4.3-5.7,4.3-11V106.5 C303.8,96.1,297.5,84.1,289.7,79.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057132943409614189270000002388173060247525054_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.3936,
    y1: 253.7665,
    x2: 223.8497,
    y2: 17.1906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4361C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1902,
    style: {
      stopColor: "#4661CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3476,
    style: {
      stopColor: "#5161D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4934,
    style: {
      stopColor: "#6260D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6314,
    style: {
      stopColor: "#7A60E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    style: {
      stopColor: "#7D60E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6557,
    style: {
      stopColor: "#7B5FE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    style: {
      stopColor: "#6C59DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    style: {
      stopColor: "#6356D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6055D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057132943409614189270000002388173060247525054_)"
    },
    d: "M289.6,79.7l-94.8-54.8 c-3.1-1.8-5.9-2.1-8.2-1.2c-0.3,0.1-4.2,2.2-4.5,2.4c0,0,0,0,0,0c2.4-1.2,5.4-1,8.8,1l94.8,54.8c7.8,4.5,14.1,16.5,14.1,26.9 v169.8c0,6.5-2.5,10.7-6.2,12c0.3,0,0.7-0.1,1.2-0.4c0.2-0.1,4.4-2.5,4.6-2.6c2.7-1.9,4.3-5.7,4.3-11V106.5 C303.6,96.2,297.3,84.2,289.6,79.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000111171571714317179280000018216364574391658158_",
    cx: 274.9181,
    cy: 93.5505,
    r: 101.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111171571714317179280000018216364574391658158_)"
    },
    d: "M286.3,81.4l-94.8-54.8 c-3.2-1.8-6.1-2.1-8.5-1.1c2-0.3,4.3,0.2,6.8,1.6L284.6,82c7.8,4.5,14.1,16.5,14.1,26.9v169.8c0,6.1-2.2,10.3-5.6,11.7 c4.3-0.7,7.3-5.1,7.3-12.2V108.3C300.3,98,294,85.9,286.3,81.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275.5,304.1c-2.5,0-4.8-0.6-6.6-1.6l-49.3-29.2l-49.3-29.2c-2.4-1.4-3.8-3.6-3.8-6c0-2.7,1.7-5.2,4.6-6.9 l9.9-6.4c2.3-1.3,5.1-2,8-2c2.5,0,4.8,0.6,6.6,1.6l50.3,29.3l50.3,29.3c2.4,1.4,3.8,3.6,3.8,6c0,2.7-1.7,5.2-4.6,6.9l-11.9,6.1 C281.2,303.4,278.4,304.1,275.5,304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M171.1,231.5l6-3.9c0.1,0,3.8-2.5,3.9-2.5c2.3-1.3,5.1-1.9,8-1.9c2.4,0,4.8,0.7,6.5,1.7l50,29.1l50,29.1 c2.1,1.2,3.6,3.3,3.8,5.4c0,0.2,0,0.3,0,0.5c0.1,2.6-1.5,5.1-4.4,6.8l-6.3,3.3c-0.1,0-5.4,2.8-5.5,2.8c-1.8,1-3.9,1.6-6.1,1.8 c-0.6,0.1-1.3,0.1-1.9,0.1c-2.4,0-4.8-0.7-6.5-1.7l-49-28.9l-49-29c-2.2-1.3-3.7-3.4-3.9-5.6c0-0.1,0-0.2,0-0.3 C166.6,235.7,168.2,233.2,171.1,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M171.3,231.7l5.9-3.9c0.1-0.1,3.7-2.4,3.9-2.4c2.3-1.2,5.1-1.7,7.9-1.8c2.3,0,4.8,0.8,6.5,1.7l49.7,29 l49.7,29c2,1.2,3.7,3.3,3.9,5.3c0,0.1,0,0.3,0,0.5c0.2,2.6-1.3,5.1-4.2,6.8l-6.2,3.3c-0.1,0.1-5.3,2.7-5.5,2.7 c-1.8,0.9-3.9,1.5-6,1.7c-0.6,0.1-1.3,0-1.9,0c-2.3,0-4.8-0.8-6.5-1.7L219.7,273L171,244.2c-2.1-1.2-3.7-3.4-3.9-5.4 c0-0.1,0-0.2,0-0.3C166.8,235.9,168.4,233.4,171.3,231.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M171.4,231.9l5.9-3.8c0.2-0.1,3.7-2.3,3.9-2.3c2.3-1.2,5.1-1.6,7.8-1.6c2.2-0.1,4.8,0.9,6.4,1.8l49.3,28.8 l49.3,28.8c1.9,1.1,3.7,3.3,4,5.2c0,0.1,0,0.3,0.1,0.4c0.3,2.5-1.2,5-4.1,6.7l-6.2,3.3c-0.2,0.1-5.2,2.6-5.5,2.6 c-1.8,0.9-3.9,1.3-6,1.5c-0.5,0-1.3,0-1.9,0c-2.2,0-4.8-0.9-6.4-1.8l-48.3-28.5l-48.4-28.6c-2-1.1-3.8-3.4-4-5.3 c0-0.1,0-0.2-0.1-0.3C167,236.1,168.5,233.6,171.4,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.5,232.1l5.8-3.8c0.2-0.1,3.6-2.2,3.9-2.3c2.3-1.1,5.1-1.4,7.8-1.5c2-0.1,4.9,1,6.3,1.9l49,28.6 l49,28.6c1.8,1.1,3.8,3.3,4,5.1c0,0.1,0.1,0.3,0.1,0.4c0.4,2.5-1,5-3.9,6.7l-6.1,3.3c-0.3,0.2-5.1,2.5-5.5,2.6 c-1.8,0.9-3.9,1.2-6,1.4c-0.5,0-1.3-0.1-1.8-0.1c-2,0-4.9-1-6.3-1.9l-47.9-28.3l-48.2-28.4c-1.9-1.1-3.8-3.3-4.1-5.2 c0-0.1,0-0.2-0.1-0.3C167.2,236.3,168.6,233.8,171.5,232.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M171.6,232.3l5.8-3.8c0.3-0.2,3.5-2.2,3.9-2.2c2.3-1.1,5.1-1.2,7.7-1.3c1.9-0.1,4.9,1.1,6.2,1.9l48.7,28.4 l48.7,28.4c1.7,1,3.8,3.3,4.1,5c0,0.1,0.1,0.3,0.1,0.4c0.5,2.4-0.8,4.9-3.7,6.6l-6,3.3c-0.4,0.2-5,2.5-5.4,2.5 c-1.8,0.8-3.9,1.1-5.9,1.2c-0.5,0-1.3-0.1-1.8-0.1c-1.9,0-4.9-1.1-6.2-1.9L220,272.5l-47.9-28.2c-1.7-1-3.9-3.3-4.2-5.1 c0-0.1-0.1-0.2-0.1-0.3C167.3,236.5,168.7,234,171.6,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M171.7,232.5l5.7-3.8c0.3-0.2,3.5-2.1,3.8-2.2c2.3-1.1,5.1-1.1,7.7-1.2c1.8-0.1,4.9,1.2,6.2,2l48.4,28.2 l48.3,28.2c1.6,0.9,3.9,3.3,4.2,4.8c0,0.1,0.1,0.3,0.1,0.4c0.6,2.4-0.7,4.9-3.6,6.6l-6,3.3c-0.4,0.2-4.9,2.4-5.4,2.4 c-1.8,0.8-3.9,1-5.9,1.1c-0.5,0-1.3-0.2-1.8-0.2c-1.8,0-4.9-1.2-6.2-2l-47.2-27.8l-47.6-28c-1.6-0.9-3.9-3.3-4.2-4.9 c0-0.1-0.1-0.2-0.1-0.3C167.5,236.7,168.8,234.2,171.7,232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M171.8,232.7l5.7-3.8c0.4-0.2,3.4-2,3.8-2.1c2.3-1,5.1-0.9,7.6-1.1c1.7-0.1,4.9,1.4,6.1,2.1l48,28l48,28 c1.5,0.9,3.9,3.2,4.2,4.7c0,0.1,0.1,0.3,0.1,0.4c0.7,2.3-0.5,4.8-3.4,6.5l-5.9,3.3c-0.5,0.3-4.8,2.3-5.4,2.4 c-1.8,0.7-3.9,0.9-5.9,0.9c-0.4,0-1.3-0.2-1.8-0.2c-1.7,0-4.9-1.4-6.1-2.1l-46.9-27.6l-47.3-27.8c-1.5-0.9-4-3.3-4.3-4.8 c0-0.1-0.1-0.2-0.1-0.3C167.7,236.9,168.9,234.4,171.8,232.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M172,232.9l5.6-3.8c0.4-0.2,3.3-2,3.8-2.1c2.3-1,5.1-0.7,7.5-0.9c1.6-0.1,4.9,1.5,6,2.1l47.7,27.8 l47.7,27.8c1.4,0.8,4,3.2,4.3,4.6c0,0.1,0.1,0.3,0.1,0.4c0.8,2.3-0.3,4.8-3.2,6.5l-5.9,3.3c-0.6,0.3-4.7,2.3-5.4,2.3 c-1.9,0.7-3.9,0.8-5.8,0.8c-0.4,0-1.3-0.2-1.7-0.2c-1.6,0-4.9-1.5-6-2.1L220.2,272l-47-27.6c-1.4-0.8-4.3-3.3-4.4-4.7 c0-0.1-0.1-0.2-0.1-0.3C167.9,237.1,169,234.6,172,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M172.1,233.1l5.6-3.7c0.5-0.3,3.2-1.9,3.8-2c2.3-0.9,5.1-0.6,7.5-0.8c1.4-0.1,4.9,1.6,6,2.2l47.4,27.6 l47.3,27.6c1.3,0.7,4.3,3.2,4.4,4.5c0.1,0.1,0.1,0.2,0.2,0.4c0.9,2.2-0.2,4.7-3.1,6.4l-5.8,3.4c-0.6,0.4-4.6,2.2-5.4,2.2 c-1.9,0.6-3.9,0.7-5.8,0.7c-0.4,0-1.3-0.3-1.7-0.3c-1.4,0-4.9-1.6-6-2.2l-46.2-27.2l-46.7-27.5c-1.3-0.8-4.4-3.3-4.5-4.6 c0-0.1-0.1-0.2-0.1-0.3C168,237.3,169.1,234.8,172.1,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M172.2,233.3l5.6-3.7c0.5-0.3,3.2-1.8,3.8-1.9c2.4-0.9,5-0.4,7.4-0.7c1.3-0.1,4.9,1.7,5.9,2.2l47.1,27.4 l47,27.4c1.2,0.7,4.4,3.2,4.4,4.4c0.1,0.1,0.1,0.2,0.2,0.4c1,2.2,0,4.7-2.9,6.4l-5.7,3.4c-0.7,0.4-4.5,2.1-5.3,2.2 c-1.9,0.6-3.9,0.6-5.8,0.5c-0.3,0-1.3-0.3-1.7-0.3c-1.3,0-4.9-1.7-5.9-2.2l-45.9-26.9L174,244.4c-1.2-0.7-4.5-3.3-4.5-4.5 c-0.1-0.1-0.1-0.2-0.2-0.3C168.2,237.5,169.3,235,172.2,233.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.3,233.5l5.5-3.7c0.6-0.3,3.1-1.8,3.8-1.9c2.4-0.8,5-0.3,7.4-0.5c1.2-0.1,5,1.8,5.8,2.3l46.7,27.2 l46.7,27.2c1.1,0.6,4.4,3.2,4.5,4.2c0.1,0.1,0.1,0.2,0.2,0.3c1.1,2.1,0.2,4.6-2.8,6.3l-5.7,3.4c-0.8,0.4-4.4,2.1-5.3,2.1 c-1.9,0.6-3.9,0.4-5.7,0.4c-0.3,0-1.3-0.4-1.7-0.4c-1.2,0-5-1.8-5.8-2.3l-45.5-26.7l-46.1-27.1c-1.1-0.6-4.5-3.2-4.6-4.3 c-0.1-0.1-0.1-0.2-0.2-0.3C168.4,237.7,169.4,235.2,172.3,233.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M172.4,233.7l5.5-3.7c0.6-0.4,3-1.7,3.8-1.8c2.4-0.8,5-0.1,7.3-0.4c1.1-0.1,5,1.9,5.7,2.4l46.4,27.1 l46.3,27c1,0.6,4.5,3.1,4.6,4.1c0.1,0.1,0.1,0.2,0.2,0.3c1.3,2.1,0.4,4.6-2.6,6.3l-5.6,3.4c-0.8,0.5-4.3,2-5.3,2 c-1.9,0.5-3.9,0.3-5.7,0.2c-0.3,0-1.4-0.4-1.6-0.4c-1.1,0-5-1.9-5.7-2.4l-45.2-26.5l-45.8-26.9c-1-0.6-4.6-3.2-4.7-4.2 c-0.1-0.1-0.1-0.2-0.2-0.3C168.5,237.9,169.5,235.4,172.4,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M172.5,233.9l5.4-3.7c0.7-0.4,3-1.6,3.8-1.8c2.4-0.8,5,0.1,7.2-0.2c0.9-0.1,5,2,5.7,2.4l46.1,26.9l46,26.8 c0.9,0.5,4.6,3.1,4.6,4c0.1,0.1,0.2,0.2,0.2,0.3c1.4,2,0.5,4.5-2.4,6.2l-5.6,3.4c-0.9,0.5-4.2,1.9-5.3,2 c-1.9,0.5-3.9,0.2-5.7,0.1c-0.2,0-1.4-0.5-1.6-0.5c-1,0-5-2-5.7-2.4l-44.8-26.3l-45.5-26.7c-0.9-0.5-4.7-3.2-4.8-4.1 c-0.1-0.1-0.1-0.2-0.2-0.3C168.7,238.1,169.6,235.6,172.5,233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M172.7,234.1l5.4-3.6c0.7-0.4,2.9-1.6,3.8-1.7c2.4-0.7,5,0.2,7.2-0.1c0.8-0.1,5,2.2,5.6,2.5l45.8,26.7 l45.7,26.6c0.8,0.4,4.7,3.1,4.7,3.9c0.1,0.1,0.2,0.2,0.2,0.3c1.5,2,0.7,4.5-2.3,6.2l-5.5,3.4c-1,0.6-4.1,1.8-5.3,1.9 c-1.9,0.4-3.9,0.4-5.6,0c-0.2,0-1.4-0.5-1.6-0.5c-0.8,0-5-2.2-5.6-2.5L220.7,271l-45.2-26.5c-0.8-0.4-4.8-3.2-4.8-4 c-0.1-0.1-0.1-0.2-0.2-0.2C168.9,238.3,169.7,235.8,172.7,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M172.8,234.3l5.3-3.6c0.8-0.5,2.8-1.5,3.8-1.6c2.4-0.7,5,0.4,7.1,0c0.7-0.1,5,2.3,5.5,2.6l45.4,26.5 l45.4,26.4c0.6,0.4,4.7,3.1,4.8,3.8c0.1,0.1,0.2,0.2,0.3,0.3c1.6,1.9,0.9,4.4-2.1,6.1l-5.4,3.4c-1.1,0.6-3.9,1.8-5.2,1.8 c-1.9,0.4-3.9,0.3-5.6-0.2c-0.2,0-1.4-0.6-1.6-0.6c-0.7,0-5-2.3-5.5-2.6l-44.1-25.8l-44.9-26.3c-0.7-0.4-4.9-3.2-4.9-3.9 c-0.1-0.1-0.2-0.2-0.2-0.2C169,238.6,169.8,236,172.8,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M172.9,234.5l5.3-3.6c0.8-0.5,2.8-1.4,3.8-1.6c2.4-0.6,5-0.6,7.1,0.2c0.6,0,5,2.4,5.4,2.6l45.1,26.3 l45,26.2c0.5,0.3,4.8,3.1,4.9,3.6c0.1,0.1,0.2,0.2,0.3,0.3c1.7,1.9,1,4.4-1.9,6.1l-5.4,3.4c-1.1,0.6-3.8,1.7-5.2,1.8 c-1.9,0.3-3.9,0.2-5.6-0.3c-0.2,0-1.4-0.6-1.5-0.6c-0.6,0-5-2.4-5.5-2.6l-43.8-25.6l-44.7-26.1c-0.5-0.3-4.9-3.2-5-3.7 c-0.1-0.1-0.2-0.2-0.2-0.2C169.2,238.8,169.9,236.2,172.9,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M173,234.7l5.2-3.6c0.9-0.5,2.7-1.3,3.8-1.5c2.4-0.6,5-0.5,7,0.3c0.5,0,5,2.5,5.4,2.7l44.8,26.1l44.7,26.1 c0.4,0.2,4.9,3.1,4.9,3.5c0.1,0.1,0.2,0.2,0.3,0.3c1.8,1.8,1.2,4.3-1.8,6L282,298c-1.2,0.7-3.7,1.6-5.2,1.7c-2,0.3-4,0.2-5.5-0.5 c-0.1,0-1.4-0.6-1.5-0.6c-0.5,0-5-2.5-5.4-2.7l-43.4-25.4l-44.4-25.9c-0.4-0.3-5-3.2-5.1-3.6c-0.1-0.1-0.2-0.1-0.3-0.2 C169.4,239,170,236.4,173,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M173.1,234.9l5.2-3.6c0.9-0.5,2.6-1.3,3.8-1.5c2.4-0.5,5-0.4,6.9,0.4c0.4,0,5,2.6,5.3,2.8l44.4,25.9 l44.4,25.9c0.3,0.2,5,3.1,5,3.4c0.1,0.1,0.2,0.2,0.3,0.3c2,1.8,1.4,4.3-1.6,6l-5.2,3.5c-1.3,0.7-3.6,1.6-5.2,1.7 c-2,0.3-4,0.1-5.5-0.6c-0.1,0-1.4-0.7-1.5-0.7c-0.4,0-5.1-2.6-5.3-2.8L221,270.4L177,244.6c-0.3-0.2-5.1-3.2-5.1-3.5 c-0.1-0.1-0.2-0.1-0.3-0.2C169.6,239.2,170.2,236.6,173.1,234.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M173.2,235.1l5.2-3.5c1-0.6,2.5-1.2,3.8-1.4c2.4-0.5,5-0.3,6.9,0.6c0.2,0,5.1,2.7,5.2,2.8l44.1,25.7 l44,25.7c0.2,0.1,5,3.1,5.1,3.3c0.1,0.1,0.2,0.2,0.3,0.2c2.1,1.7,1.5,4.2-1.4,5.9l-5.2,3.5c-1.3,0.8-3.5,1.5-5.2,1.6 c-2,0.2-4,0-5.4-0.7c-0.1,0-1.4-0.7-1.5-0.7c-0.2,0-5.1-2.7-5.2-2.8l-42.7-25l-43.8-25.6c-0.2-0.1-5.2-3.1-5.2-3.4 c-0.1-0.1-0.2-0.1-0.3-0.2C169.7,239.4,170.3,236.8,173.2,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M173.4,235.3l5.1-3.5c1-0.6,2.5-1.1,3.7-1.4c2.4-0.5,5-0.2,6.8,0.7c0.1,0,5.1,2.8,5.2,2.9l43.8,25.5 l43.7,25.5c0.1,0.1,5.1,3,5.1,3.1c0.1,0.1,0.2,0.2,0.3,0.2c2.2,1.6,1.7,4.2-1.3,5.9l-5.1,3.5c-1.4,0.8-3.4,1.4-5.1,1.5 c-2,0.2-4-0.1-5.4-0.9c0,0-1.4-0.8-1.4-0.8c-0.1,0-5.1-2.9-5.2-2.9L221.2,270l-43.5-25.4c-0.1-0.1-5.3-3.1-5.3-3.2 c-0.1-0.1-0.2-0.1-0.3-0.2C169.9,239.6,170.4,237,173.4,235.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M269.8,298.2l-48.6-28.3l-48.6-28.3c-2.7-1.6-2.4-4.3,0.8-6.1l5.1-3.5c3.1-1.8,7.8-2,10.5-0.4l48.6,28.3 l48.6,28.3c2.7,1.6,2.4,4.3-0.8,6.1l-5.1,3.5C277.2,299.6,272.5,299.7,269.8,298.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183208225323595348590000004730877494842672789_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.3898,
    y1: 239.1829,
    x2: 274.0426,
    y2: 96.0241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01274822,
    style: {
      stopColor: "#D3D8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05627469,
    style: {
      stopColor: "#E1E5FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0959596,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#EAEDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183208225323595348590000004730877494842672789_)"
    },
    d: "M184.1,32.2c0,1.3-0.1,141.4-0.1,159.2 c0,9.6,0,26,0,26.1c0,6.5-4.2,14.2-9.6,18.3c9.3,5.4,63.9,36.5,79.7,45.7H268c0,6.2,0,11.2,0,11.3c0,4.5,3.1,7.3,6.1,7.9 c0,0,0,0,0,0c0.2,0,0.5,0.1,0.8,0.1c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0c1.4-0.1,2.9-0.6,4.5-1.5c1.7-1,3.3-2.4,4.8-4 c1.8-1.6,3.1-3.7,4-6c1.5-3.1,2.5-6.4,2.5-9.5c0-0.1,0.1-1.2,0.1-4.2c0-0.7,0.1-181,0.1-181.8L184.1,32.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M243.7,215c0,0.2,1,0.9,2.6,1.9c0-0.2,0-0.3,0-0.5C244.7,215.5,243.7,215,243.7,215z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "253.3,250.6 282.9,267.7 282.9,264.7 253.3,247.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "274.4,270.3 282.9,275.4 282.9,272.4 274.4,267.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "271.4,268.6 271.4,265.6 194.2,221.7 194.2,224.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "264.1,249.2 282.9,260 282.9,257 264.1,246.1  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "191.9,98 191.9,101 262.4,141.2 262.4,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "239,140.3 191.9,113.2 191.9,116.2 239,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "227.1,125.7 191.9,105.4 191.9,108.5 227.1,128.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "230,127.4 230,130.4 283.2,160.7 283.2,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "242,142 242,145 276.5,164.8 276.5,161.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M313.8,263.1l-68.1-39.3c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.8-2.6,5.9-2.6 c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.5,3-6.6,3.1 C313.4,265.9,315.7,264.2,313.8,263.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173133851498167648050000013758533918939120571_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6272,
    y1: 128.2843,
    x2: 310.6003,
    y2: 282.5489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0B7E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#B2B8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#B3B9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B0B7E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173133851498167648050000013758533918939120571_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.7-2.6,5.8-2.6c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.4,3-6.5,3C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038407207476398331640000001943895508833535919_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.5809,
    y1: 128.3033,
    x2: 310.5526,
    y2: 282.5639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#B4BBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#B7BDE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B9E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038407207476398331640000001943895508833535919_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.6-2.5,5.7-2.6c1.6-0.6,3.2-0.9,5.3,0.3L316,158 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.3,3-6.4,3C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091013251397010118250000010713170386884496817_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.5345,
    y1: 128.3223,
    x2: 310.505,
    y2: 282.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3BAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#B7BDE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#BAC0E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3BAE7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091013251397010118250000010713170386884496817_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.5-2.5,5.6-2.5c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.2,2.9-6.3,3C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132810539960694928000000016847318651248039313_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.4882,
    y1: 128.3413,
    x2: 310.4574,
    y2: 282.5939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BBE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#B9C0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#BEC4EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5BBE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132810539960694928000000016847318651248039313_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.4-2.5,5.5-2.5c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.1,2.9-6.3,2.9C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153666945731938632070000017606577461036650635_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.4419,
    y1: 128.3603,
    x2: 310.4097,
    y2: 282.6089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6BDE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#BCC2EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#C2C7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6BDE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153666945731938632070000017606577461036650635_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.3-2.4,5.4-2.5c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6.1,2.9-6.2,2.9C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093875672567527140530000014042849807516225725_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3955,
    y1: 128.3793,
    x2: 310.3621,
    y2: 282.624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8BEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#BEC5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#C6CBEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    style: {
      stopColor: "#B2B9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B8BEE9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093875672567527140530000014042849807516225725_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.2-2.4,5.3-2.4c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-6,2.8-6.1,2.9C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067211991286876710010000014706042987616288429_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3492,
    y1: 128.3983,
    x2: 310.3145,
    y2: 282.639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9BFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#C1C7EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#CACEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    style: {
      stopColor: "#B6BDE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9BFEA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067211991286876710010000014706042987616288429_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.1-2.4,5.2-2.4c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.9,2.8-6,2.8C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046304222049481975000000012508690988610659719_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3028,
    y1: 128.4173,
    x2: 310.2668,
    y2: 282.654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BAC1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#C4C9EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#CDD2EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#B9C0E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#BAC1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BAC1EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046304222049481975000000012508690988610659719_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5.1-2.3,5.1-2.4c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.8,2.8-5.9,2.8C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152976245012489907670000008767991370809341625_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.2565,
    y1: 128.4363,
    x2: 310.2192,
    y2: 282.669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#C6CCF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    style: {
      stopColor: "#D0D4F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#D1D5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    style: {
      stopColor: "#BDC3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCC2EB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152976245012489907670000008767991370809341625_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,5-2.3,5-2.3c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.7,2.7-5.8,2.8C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098914325373756288010000000809973995224960147_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.2101,
    y1: 128.4553,
    x2: 310.1716,
    y2: 282.6841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#C9CEF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    style: {
      stopColor: "#D3D7F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#D5D9F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3538,
    style: {
      stopColor: "#C1C7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDC3EC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098914325373756288010000000809973995224960147_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.9-2.3,4.9-2.3c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.6,2.7-5.7,2.7C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079485422694156781140000016263441838079305904_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.1638,
    y1: 128.4743,
    x2: 310.124,
    y2: 282.6991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFC5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#CBD1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2627,
    style: {
      stopColor: "#D5D9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#D9DCF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3478,
    style: {
      stopColor: "#C5CAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC5EC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079485422694156781140000016263441838079305904_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.8-2.2,4.8-2.3c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.5,2.6-5.6,2.7C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139973460108138904500000006676696586528500631_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.1175,
    y1: 128.4933,
    x2: 310.0763,
    y2: 282.7141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0C6ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    style: {
      stopColor: "#D8DCF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#DDE0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3431,
    style: {
      stopColor: "#C9CEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0C6ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139973460108138904500000006676696586528500631_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.7-2.2,4.7-2.2c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.4,2.6-5.5,2.6C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180333531985500525070000014942161482303376294_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0711,
    y1: 128.5123,
    x2: 310.0287,
    y2: 282.7291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C7EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#D0D6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#DADEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#E1E3F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3388,
    style: {
      stopColor: "#CDD1EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2C7EE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180333531985500525070000014942161482303376294_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.6-2.2,4.6-2.2c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.3,2.6-5.4,2.6C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010993513651253355030000017827141753546455952_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0248,
    y1: 128.5313,
    x2: 309.981,
    y2: 282.7442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#D3D8F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#DDE1F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#E4E7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    style: {
      stopColor: "#D0D5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C9EE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010993513651253355030000017827141753546455952_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.5-2.1,4.6-2.2c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.2,2.5-5.3,2.6C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123406211130599885540000001072810490291045021_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.9785,
    y1: 128.5503,
    x2: 309.9334,
    y2: 282.7592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#D6DAF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2504,
    style: {
      stopColor: "#E0E3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#E8EAF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3328,
    style: {
      stopColor: "#D4D8F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4CAEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123406211130599885540000001072810490291045021_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.4-2.1,4.5-2.1c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5.1,2.5-5.2,2.5C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165926040874465102370000013854959454634359705_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.9321,
    y1: 128.5693,
    x2: 309.8858,
    y2: 282.7742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6CBF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#D8DDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    style: {
      stopColor: "#E2E6F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#ECEEF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3299,
    style: {
      stopColor: "#D8DCF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6CBF0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165926040874465102370000013854959454634359705_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.3-2.1,4.4-2.1c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-5,2.5-5.1,2.5C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080177988313435777300000005002953257879981712_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.8857,
    y1: 128.5882,
    x2: 309.8382,
    y2: 282.7892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C7CDF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#DBDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2439,
    style: {
      stopColor: "#E5E8FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#F0F1FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    style: {
      stopColor: "#DCDFF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CDF0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080177988313435777300000005002953257879981712_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.2-2,4.3-2.1c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-4.9,2.4-5,2.5C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147218465811220682280000011071649322877639561_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.8394,
    y1: 128.6072,
    x2: 309.7906,
    y2: 282.8043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9CEF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#DDE2FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    style: {
      stopColor: "#E7EAFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#F4F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3252,
    style: {
      stopColor: "#E0E3F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9CEF1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147218465811220682280000011071649322877639561_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4.1-2,4.2-2c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-4.8,2.4-4.9,2.4C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103229489965468449310000008720022740621382060_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.7931,
    y1: 128.6262,
    x2: 309.7429,
    y2: 282.8193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#E0E4FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    style: {
      stopColor: "#EAEDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    style: {
      stopColor: "#E3E6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4066,
    style: {
      stopColor: "#B1B8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9539,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CACFF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103229489965468449310000008720022740621382060_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,4-2,4.1-2c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-4.7,2.4-4.8,2.4C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039092544509938402030000017743498443988218530_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.7467,
    y1: 128.6452,
    x2: 309.6953,
    y2: 282.8343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCD1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#E2E7FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    style: {
      stopColor: "#ECEFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#FBFCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3217,
    style: {
      stopColor: "#E7EAF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4009,
    style: {
      stopColor: "#B5BBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD1F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039092544509938402030000017743498443988218530_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,3.9-1.9,4-1.9c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-4.6,2.3-4.8,2.4C313.4,265.9,315.7,264.2,313.8,263.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042702120279866019880000002006355825089416872_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.7004,
    y1: 128.6642,
    x2: 309.6477,
    y2: 282.8493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2361,
    style: {
      stopColor: "#EFF2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3201,
    style: {
      stopColor: "#EBEDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3957,
    style: {
      stopColor: "#B9BFE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    style: {
      stopColor: "#BAC0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDD2F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042702120279866019880000002006355825089416872_)"
    },
    d: "M313.8,263.1l-68.1-39.3 c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-2.9-2.4-3.6-0.9-4.6c0.1,0,3.8-1.9,3.9-1.9c1.6-0.6,3.2-0.9,5.3,0.3l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8v83.4c0,3-1,5.2-2.5,6.2c-0.1,0.1-4.6,2.3-4.7,2.3C313.4,265.9,315.7,264.2,313.8,263.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M310.2,264.8l-68.1-39.3c-4.3-2.5-7.8-9.1-7.8-14.8v-83.4c0-5.7,3.5-8.3,7.8-5.9l68.1,39.3 c4.3,2.5,7.8,9.1,7.8,14.8V259C317.9,264.7,314.5,267.3,310.2,264.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066506287062337372100000001818598915518163091_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.5957,
    y1: 240.7263,
    x2: 315.9436,
    y2: 146.3061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#B6BCE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    style: {
      stopColor: "#C8CDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    style: {
      stopColor: "#F5F6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066506287062337372100000001818598915518163091_)"
    },
    d: "M313.3,265c-0.8,0-1.7-0.3-2.7-0.8 l-68.1-39.3c-4.1-2.4-7.4-8.7-7.4-14.2v-83.4c0-3.7,1.5-6,3.9-6c0.8,0,1.7,0.3,2.7,0.8l68.1,39.3c4.1,2.3,7.4,8.7,7.4,14.2V259 C317.2,262.6,315.6,265,313.3,265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018237252854080408410000010968091520437074841_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.951,
    y1: 172.8667,
    x2: 244.1646,
    y2: 159.4303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#BB6DF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3625,
    style: {
      stopColor: "#CA6DEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F36DD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F36DD4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018237252854080408410000010968091520437074841_)"
    },
    d: "M254.6,173l-8.9-5.1 c-1.7-1-3.1-3.7-3.1-6v-0.1c0-2.3,1.4-3.3,3.1-2.4l8.9,5.1c1.7,1,3.1,3.7,3.1,6v0.1C257.7,173,256.3,174,254.6,173z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017481944273332667850000008168653634141139341_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.2968,
    y1: 185.9473,
    x2: 262.7461,
    y2: 169.4463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#BB6DF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3625,
    style: {
      stopColor: "#CA6DEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F36DD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F36DD4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017481944273332667850000008168653634141139341_)"
    },
    d: "M272,183.1l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-1.3c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v1.3C275.1,183.3,273.7,184.1,272,183.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104665232043248796570000001104843283448448917_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.9715,
    y1: 194.5828,
    x2: 278.2993,
    y2: 178.5534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104665232043248796570000001104843283448448917_)"
    },
    d: "M289.4,193.1l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-1.3c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v1.3C292.5,193.3,291.1,194.1,289.4,193.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025407172678628992790000008641523252701647796_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.4345,
    y1: 205.2508,
    x2: 295.5836,
    y2: 188.9855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025407172678628992790000008641523252701647796_)"
    },
    d: "M306.8,203.1l-8.9-5.1 c-1.7-1-3.1-3.7-3.1-6v-0.1c0-2.3,1.4-3.3,3.1-2.4l8.9,5.1c1.7,1,3.1,3.7,3.1,6v0.1C309.9,203.1,308.5,204.1,306.8,203.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075121971123705299860000018147075489137738426_",
    gradientUnits: "userSpaceOnUse",
    x1: -2120.5186,
    y1: 2035.1321,
    x2: -2131.2661,
    y2: 2021.9963,
    gradientTransform: "matrix(0.866 0.5 0.5 1.4434 1077.6742 -1683.1239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075121971123705299860000018147075489137738426_)"
    },
    d: "M254.6,187.9l-8.9-5.1 c-1.7-1-3.1-3.7-3.1-6v-1c0-2.3,1.4-3.3,3.1-2.4l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1C257.7,187.9,256.3,188.9,254.6,187.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107551727148127902340000004068876041201296536_",
    gradientUnits: "userSpaceOnUse",
    x1: -343.6281,
    y1: 2036.6705,
    x2: -356.373,
    y2: 2021.0933,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107551727148127902340000004068876041201296536_)"
    },
    d: "M272,198l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C275.1,198.2,273.7,199,272,198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146500364733221911400000016381468074716338824_",
    gradientUnits: "userSpaceOnUse",
    x1: -323.5401,
    y1: 2036.6703,
    x2: -336.2852,
    y2: 2021.093,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146500364733221911400000016381468074716338824_)"
    },
    d: "M289.4,208l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C292.5,208.2,291.1,209,289.4,208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152238103061458920530000004197260919761105572_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.4984,
    y1: 219.5708,
    x2: 297.9161,
    y2: 203.4552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152238103061458920530000004197260919761105572_)"
    },
    d: "M306.8,218.1l-8.9-5.1 c-1.7-1-3.1-3.7-3.1-6v-1c0-2.3,1.4-3.3,3.1-2.4l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1C309.9,218,308.5,219.1,306.8,218.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150819365954980597610000010863582955141940903_",
    gradientUnits: "userSpaceOnUse",
    x1: -363.716,
    y1: 2047.0591,
    x2: -376.461,
    y2: 2031.4818,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150819365954980597610000010863582955141940903_)"
    },
    d: "M254.6,199.9l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C257.7,200.1,256.3,200.9,254.6,199.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026132446773734355490000014513420709202351277_",
    gradientUnits: "userSpaceOnUse",
    x1: -343.6281,
    y1: 2047.0588,
    x2: -356.373,
    y2: 2031.4816,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026132446773734355490000014513420709202351277_)"
    },
    d: "M272,210l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C275.1,210.2,273.7,211,272,210z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170266729935681711260000006814954967255878544_",
    gradientUnits: "userSpaceOnUse",
    x1: -323.5401,
    y1: 2047.0586,
    x2: -336.2852,
    y2: 2031.4813,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170266729935681711260000006814954967255878544_)"
    },
    d: "M289.4,220l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C292.5,220.2,291.1,221,289.4,220z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087376760407035852710000016451467712860202394_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.9469,
    y1: 230.5344,
    x2: 295.0687,
    y2: 214.4533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087376760407035852710000016451467712860202394_)"
    },
    d: "M306.8,230.1l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C309.9,230.3,308.5,231.1,306.8,230.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000922598404503979860000011499717987545424531_",
    gradientUnits: "userSpaceOnUse",
    x1: -363.716,
    y1: 2057.4475,
    x2: -376.461,
    y2: 2041.8701,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000922598404503979860000011499717987545424531_)"
    },
    d: "M254.6,211.9l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C257.7,212.1,256.3,212.9,254.6,211.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084499302938619461100000016004726420662734242_",
    gradientUnits: "userSpaceOnUse",
    x1: -343.628,
    y1: 2057.4473,
    x2: -356.373,
    y2: 2041.8699,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084499302938619461100000016004726420662734242_)"
    },
    d: "M272,222l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C275.1,222.2,273.7,223,272,222z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096031908329127975830000004055923014964765359_",
    gradientUnits: "userSpaceOnUse",
    x1: -323.5401,
    y1: 2057.447,
    x2: -336.2852,
    y2: 2041.8696,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096031908329127975830000004055923014964765359_)"
    },
    d: "M289.4,232l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C292.5,232.2,291.1,233,289.4,232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023277019418487076020000017301325473858833563_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.512,
    y1: 2066.2966,
    x2: -2149.2595,
    y2: 2053.1609,
    gradientTransform: "matrix(0.866 0.5 0.5 1.4434 1077.6742 -1683.1239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023277019418487076020000017301325473858833563_)"
    },
    d: "M254.6,223.9l-8.9-5.1 c-1.7-1-3.1-3.7-3.1-6v-1c0-2.3,1.4-3.3,3.1-2.4l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1C257.7,223.9,256.3,224.9,254.6,223.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029027939440864300580000002155543287482661810_",
    gradientUnits: "userSpaceOnUse",
    x1: -343.628,
    y1: 2067.8354,
    x2: -356.373,
    y2: 2052.2583,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 571.1848 -1975.7451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029027939440864300580000002155543287482661810_)"
    },
    d: "M272,234l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C275.1,234.2,273.7,235,272,234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106856365477369721180000006066967978179596974_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.5558,
    y1: 248.5752,
    x2: 277.0601,
    y2: 227.1917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106856365477369721180000006066967978179596974_)"
    },
    d: "M289.4,244l-8.9-5.1 c-1.7-1-3.1-3.4-3.1-5.4v-2.1c0-2,1.4-2.8,3.1-1.8l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1C292.5,244.2,291.1,245,289.4,244z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155106255816691142470000006195811167532957569_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.2294,
    y1: 253.7525,
    x2: 291.2347,
    y2: 226.3309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155106255816691142470000006195811167532957569_)"
    },
    d: "M306.8,232.8l-8.9-5.1 c-1.7-1-3.1-0.2-3.1,1.8V243c0,2.3,1.4,5,3.1,6l8.9,5.1c1.7,1,3.1-0.1,3.1-2.4v-13.6C309.9,236.2,308.5,233.8,306.8,232.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000151534531545346724740000002938531054726104967_",
    cx: 136.5402,
    cy: 268.157,
    r: 7.6664,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151534531545346724740000002938531054726104967_)"
    },
    d: "M272,224.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V230C275.1,228.1,273.7,225.7,272,224.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097485283017605449230000000619812985452797827_",
    cx: 136.5402,
    cy: 255.7638,
    r: 7.6664,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097485283017605449230000000619812985452797827_)"
    },
    d: "M272,212.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V218C275.1,216.1,273.7,213.7,272,212.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154405303034704502940000015287363678897063087_",
    cx: 136.5402,
    cy: 243.3706,
    r: 7.6663,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154405303034704502940000015287363678897063087_)"
    },
    d: "M272,200.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C275.1,204.1,273.7,201.7,272,200.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109028160403103976280000001505806111714211739_",
    cx: 136.5402,
    cy: 230.9774,
    r: 7.6664,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109028160403103976280000001505806111714211739_)"
    },
    d: "M272,188.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C275.1,192.1,273.7,189.7,272,188.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026150848356822771790000010419362882204984990_",
    cx: 118.5672,
    cy: 232.994,
    r: 7.6662,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026150848356822771790000010419362882204984990_)"
    },
    d: "M254.6,190.6l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V196C257.7,194,256.3,191.6,254.6,190.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093167036028626110550000012109670444156580002_",
    cx: 118.5672,
    cy: 245.3871,
    r: 7.6662,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093167036028626110550000012109670444156580002_)"
    },
    d: "M254.6,202.6l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V208C257.7,206,256.3,203.6,254.6,202.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121963575862449804780000017829365018505021313_",
    cx: 118.6233,
    cy: 220.5624,
    r: 7.5897,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121963575862449804780000017829365018505021313_)"
    },
    d: "M254.6,178.6l-8.9-5.1 c-1.2-0.7-2.3-0.4-2.8,0.7c0.6-0.6,1.4-0.7,2.4-0.2l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-1C257.7,182.3,256.3,179.6,254.6,178.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000112633110476997074050000010891041538201077124_",
    cx: 118.6233,
    cy: 257.742,
    r: 7.5897,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112633110476997074050000010891041538201077124_)"
    },
    d: "M254.6,214.6l-8.9-5.1 c-1.2-0.7-2.3-0.4-2.8,0.7c0.6-0.6,1.4-0.7,2.4-0.2l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-1C257.7,218.3,256.3,215.6,254.6,214.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132784847233285039500000009919152607334081950_",
    cx: 136.5402,
    cy: 216.0001,
    r: 7.4503,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132784847233285039500000009919152607334081950_)"
    },
    d: "M272,174.6l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v1.3c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V180C275.1,178,273.7,175.6,272,174.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000126288289139270875860000002670525738420103346_",
    cx: 118.6233,
    cy: 205.585,
    r: 7.3743,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126288289139270875860000002670525738420103346_)"
    },
    d: "M254.6,164.6l-8.9-5.1 c-1.2-0.7-2.3-0.4-2.8,0.7c0.6-0.6,1.4-0.7,2.4-0.2l8.9,5.1c1.7,1,3.1,3.7,3.1,6v0.1c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-0.1C257.7,168.2,256.3,165.6,254.6,164.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016057428232772247250000007880392748732600451_",
    cx: 154.5133,
    cy: 278.5339,
    r: 7.6663,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016057428232772247250000007880392748732600451_)"
    },
    d: "M289.4,234.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C292.5,238.1,291.1,235.7,289.4,234.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047038436880912043400000018339966469088746170_",
    cx: 172.4859,
    cy: 282.6464,
    r: 11.1543,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047038436880912043400000018339966469088746170_)"
    },
    d: "M306.8,232.8l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v13.6c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-13.6C309.9,236.2,308.5,233.8,306.8,232.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004504864140297779680000006314091922005726611_",
    cx: 172.4866,
    cy: 264.1242,
    r: 7.6662,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004504864140297779680000006314091922005726611_)"
    },
    d: "M306.8,220.8l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C309.9,224.2,308.5,221.8,306.8,220.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000156546235510388413970000010120957148349825158_",
    cx: 172.5427,
    cy: 236.7153,
    r: 7.3743,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156546235510388413970000010120957148349825158_)"
    },
    d: "M306.8,194.7l-8.9-5.1 c-1.2-0.7-2.3-0.4-2.8,0.7c0.6-0.6,1.4-0.7,2.4-0.2l8.9,5.1c1.7,1,3.1,3.7,3.1,6v0.1c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-0.1C309.9,198.4,308.5,195.7,306.8,194.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031204218569801071760000015851974015416672167_",
    cx: 172.5427,
    cy: 251.6927,
    r: 7.5897,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031204218569801071760000015851974015416672167_)"
    },
    d: "M306.8,208.8l-8.9-5.1 c-1.2-0.7-2.3-0.4-2.8,0.7c0.6-0.6,1.4-0.7,2.4-0.2l8.9,5.1c1.7,1,3.1,3.7,3.1,6v1c0,0.7-0.1,1.2-0.3,1.7 c0.4-0.5,0.7-1.2,0.7-2.2v-1C309.9,212.4,308.5,209.8,306.8,208.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013166573768853064830000015945818959236903099_",
    cx: 154.5133,
    cy: 253.7475,
    r: 7.6662,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013166573768853064830000015945818959236903099_)"
    },
    d: "M289.4,210.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C292.5,214.1,291.1,211.7,289.4,210.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173148520432556088990000014346794239698854052_",
    cx: 154.5133,
    cy: 266.1407,
    r: 7.6663,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173148520432556088990000014346794239698854052_)"
    },
    d: "M289.4,222.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C292.5,226.1,291.1,223.7,289.4,222.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000178166916095782718170000002390207544337043606_",
    cx: 154.5133,
    cy: 241.3543,
    r: 7.6663,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178166916095782718170000002390207544337043606_)"
    },
    d: "M289.4,198.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v2.1c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7v-2.1C292.5,202.1,291.1,199.7,289.4,198.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000061467541894984694830000007277459458428049565_",
    cx: 154.5133,
    cy: 226.3769,
    r: 7.4502,
    gradientTransform: "matrix(0.9679 0 0 0.9679 135.482 -33.0283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061467541894984694830000007277459458428049565_)"
    },
    d: "M289.4,184.7l-8.9-5.1 c-1.3-0.8-2.4-0.5-2.9,0.6c0.6-0.6,1.5-0.6,2.5,0l8.9,5.1c1.7,1,3.1,3.4,3.1,5.4v1.3c0,0.5-0.1,0.9-0.2,1.2 c0.4-0.4,0.6-1,0.6-1.7V190C292.5,188.1,291.1,185.7,289.4,184.7z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M308.1,191.7c-0.6,0-1.2-0.2-1.8-0.5l-61.8-35.7c-2-1.2-3.5-4-3.5-6.6v-14.4c0-2.7,1.6-3.9,3.1-3.9 c0.6,0,1.2,0.2,1.8,0.5l61.8,35.7c2,1.2,3.5,4,3.5,6.6v14.4C311.2,190.5,309.6,191.7,308.1,191.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M305.7,186.1l-59.3-34.2c-1.5-0.9-2.7-3.2-2.7-5.1v-8.4c0-2,1.2-2.9,2.7-2l59.3,34.2 c1.5,0.9,2.7,3.2,2.7,5.1v8.4C308.4,186,307.2,186.9,305.7,186.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M306.7,185.4l-59.3-34.2c-1.5-0.9-2.7-3.2-2.7-5.1v-8.4c0-0.7,0.2-1.2,0.4-1.6c-0.8,0.1-1.4,1-1.4,2.3v8.4 c0,2,1.2,4.3,2.7,5.1l59.3,34.2c1,0.6,1.8,0.4,2.3-0.4C307.6,185.7,307.2,185.7,306.7,185.4z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M189.8,117.1c-8.7-5-15.7-1-15.7,8.9v100.7c0,9.9,7,22,15.7,27l71.2,38.9c8.7,5,19.1,0.4,19.1-9.5V182.4 c0-9.9-10.5-21.5-19.1-26.5L189.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M190.3,118.3c-8.6-5-15.6-1-15.6,8.9v97.6c0,9.9,7,21.9,15.6,26.9l70.2,38.3c8.6,5,18.8,0.5,18.8-9.4V183 c0-9.9-10.1-21.4-18.8-26.4L190.3,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M190.8,119.6c-8.6-4.9-15.5-1-15.5,8.9v94.5c0,9.8,6.9,21.8,15.5,26.8l69.2,37.7 c8.6,4.9,18.4,0.5,18.4-9.3v-94.5c0-9.8-9.8-21.4-18.4-26.3L190.8,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M191.3,120.8c-8.5-4.9-15.4-1-15.4,8.8V221c0,9.8,6.9,21.7,15.4,26.6l68.2,37.1c8.5,4.9,18,0.6,18-9.2 v-91.4c0-9.8-9.4-21.3-18-26.2L191.3,120.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M191.8,122c-8.5-4.9-15.4-1-15.4,8.8v88.3c0,9.7,6.9,21.6,15.4,26.5l67.2,36.5c8.5,4.9,17.6,0.6,17.6-9.1 v-88.3c0-9.7-9.1-21.3-17.6-26.2L191.8,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M192.2,123.2c-8.4-4.9-15.3-1-15.3,8.7v85.3c0,9.7,6.8,21.5,15.3,26.4l66.2,36c8.4,4.9,17.2,0.7,17.2-9 v-85.3c0-9.7-8.7-21.2-17.2-26.1L192.2,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M192.7,124.5c-8.4-4.9-15.2-1-15.2,8.7v82.2c0,9.6,6.8,21.4,15.2,26.2l65.2,35.4 c8.4,4.9,16.8,0.7,16.8-8.9v-82.2c0-9.6-8.4-21.1-16.8-26L192.7,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M193.2,125.7c-8.4-4.8-15.1-1-15.1,8.6v79.1c0,9.6,6.8,21.3,15.1,26.1l64.2,34.8 c8.4,4.8,16.4,0.8,16.4-8.8v-79.1c0-9.6-8-21.1-16.4-25.9L193.2,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M193.7,126.9c-8.3-4.8-15.1-1-15.1,8.6v76c0,9.5,6.7,21.2,15.1,26l63.2,34.2c8.3,4.8,16,0.8,16-8.7v-76 c0-9.5-7.7-21-16-25.8L193.7,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M194.2,128.1c-8.3-4.8-15-1-15,8.5v72.9c0,9.5,6.7,21.1,15,25.9l62.2,33.7c8.3,4.8,15.6,0.9,15.6-8.6 v-72.9c0-9.5-7.3-21-15.6-25.8L194.2,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M194.7,129.4c-8.2-4.8-14.9-0.9-14.9,8.5v69.9c0,9.4,6.7,21,14.9,25.7l61.2,33.1 c8.2,4.8,15.2,0.9,15.2-8.6v-69.9c0-9.4-7-20.9-15.2-25.7L194.7,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M195.2,130.6c-8.2-4.7-14.8-0.9-14.8,8.5v66.8c0,9.4,6.6,20.9,14.8,25.6l60.2,32.5 c8.2,4.7,14.8,0.9,14.8-8.5v-66.8c0-9.4-6.6-20.9-14.8-25.6L195.2,130.6z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M184.1,121.2c-8.8-5.1-16-1-16,9.1v93.3c0,10.1,7.1,22.5,16,27.5l88,48.9c8.8,5.1,4.2-5.9,4.2-16v-93.3 c0-10.1-10.7-21.9-19.5-27L184.1,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M183.9,121.5c-8.8-5.1-15.9-1-15.9,9.1v84.8c0,10.1,7.1,30.3,15.9,35.4l86.4,48.2 c8.8,5.1,5.2-5.3,5.2-15.4v-84.8c0-10.1-10.4-29.8-19.2-34.9L183.9,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M183.7,121.8c-8.8-5.1-15.9-1-15.9,9.1v76.2c0,10.1,7.1,38.1,15.9,43.2l84.7,47.4 c8.8,5.1,6.3-4.6,6.3-14.7v-76.2c0-10.1-10-37.6-18.8-42.7L183.7,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M183.5,122.1c-8.8-5.1-15.9-1-15.9,9.1v67.7c0,10.1,7.1,45.9,15.9,51l83.1,46.7c8.8,5.1,7.3-4,7.3-14.1 v-67.7c0-10.1-9.7-45.5-18.5-50.6L183.5,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M183.3,122.3c-8.8-5.1-15.9-1-15.9,9.1v59.2c0,10.1,7.1,53.8,15.9,58.8l81.4,46 c8.8,5.1,8.4-3.4,8.4-13.4v-59.2c0-10.1-9.4-53.4-18.1-58.5L183.3,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M183.1,122.6c-8.8-5.1-15.9-1-15.9,9v50.6c0,10.1,7.1,61.6,15.9,66.6l79.8,45.3 c8.8,5.1,9.4-2.7,9.4-12.8v-50.6c0-10.1-9-61.3-17.8-66.3L183.1,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M182.9,122.9c-8.8-5.1-15.8-1-15.8,9v42.1c0,10,7.1,69.4,15.8,74.5l78.1,44.5 c8.8,5.1,10.5-2.1,10.5-12.2v-42.1c0-10-8.7-69.2-17.5-74.2L182.9,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M182.7,123.2c-8.7-5-15.8-1-15.8,9v33.6c0,10,7.1,77.2,15.8,82.3l76.5,43.8c8.7,5,11.5-1.5,11.5-11.5 v-33.6c0-10-8.4-77-17.1-82.1L182.7,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M182.5,123.5c-8.7-5-15.8-1-15.8,9v25.1c0,10,7.1,85.1,15.8,90.1l74.8,43.1c8.7,5,12.6-0.9,12.6-10.9 v-25.1c0-10-8-84.9-16.8-89.9L182.5,123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M182.3,123.8c-8.7-5-15.8-1-15.8,9v16.5c0,10,7.1,92.9,15.8,97.9l73.2,42.4c8.7,5,13.6-0.2,13.6-10.3 v-16.5c0-10-7.7-92.8-16.4-97.8L182.3,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M182.1,124.1c-8.7-5-15.8-1-15.8,9v8c0,10,7.1,100.7,15.8,105.7l71.5,41.6c8.7,5,14.7,0.4,14.7-9.6v-8 c0-10-7.4-100.7-16.1-105.7L182.1,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M181.9,124.4c-8.7-5-15.7-1-15.7,9v-0.5c0,10,7.1,108.5,15.7,113.6l69.9,40.9c8.7,5,15.7,1,15.7-9v0.5 c0-10-7.1-108.5-15.7-113.6L181.9,124.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M269.2,292.7c0-0.1,0-105.5,0-114.6c-0.2-1.5-0.3-2.4-0.3-2.5c-0.2-6.8-5.2-9.4-11.3-5.9 c-6.1,3.5-11,11.9-11.3,18.9c0,0.1,0,90.8,0,96.5c6.4,3.7,26.6,15.2,26.6,15.2c0,0,0-0.1,0-0.1 C270.6,299.2,269.2,296.6,269.2,292.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M228.3,148.8c-8.8-5.1-73.1-18-73.1-7.9v86.6c0,10.1-5.3,44.8,3.5,49.9l72.7,42.6 c8.8,5.1,31.9-13.2,31.9-23.3v-95.3c0-10.1,11.1-26.8,2.3-31.9L228.3,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M225.1,147.8c-8.8-5.1-70.4-17.2-70.4-7.1v86.3c0,10.1-4.7,43.7,4.1,48.8l72.6,42.5 c8.8,5.1,31.2-12.5,31.2-22.6V201c0-10.1,10.3-26.6,1.5-31.6L225.1,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M221.8,146.7c-8.8-5.1-67.6-16.4-67.6-6.3v85.9c0,10.1-4.1,42.6,4.7,47.7l72.5,42.4 c8.8,5.1,30.4-11.8,30.4-21.9v-93.8c0-10.1,9.4-26.3,0.6-31.4L221.8,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218.5,145.6c-8.8-5.1-64.9-15.6-64.9-5.5v85.6c0,10.1-3.5,41.5,5.3,46.6l72.3,42.3 c8.8,5.1,29.6-11.1,29.6-21.2v-93c0-10.1,8.5-26.1-0.3-31.2L218.5,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.2,144.5c-8.8-5.1-62.2-14.8-62.2-4.7V225c0,10.1-2.9,40.5,5.9,45.5l72.2,42.3 c8.8,5.1,28.9-10.5,28.9-20.6V200c0-10.1,7.7-25.9-1.1-31L215.2,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M212,143.4c-8.8-5.1-59.4-14-59.4-3.9v84.8c0,10.1-2.4,39.4,6.4,44.5l72,42.2c8.8,5.1,28.1-9.8,28.1-19.9 v-91.5c0-10.1,6.8-25.7-2-30.7L212,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M208.7,142.3c-8.8-5.1-56.7-13.2-56.7-3.1v84.5c0,10.1-1.8,38.3,7,43.4l71.9,42.1 c8.8,5.1,27.3-9.1,27.3-19.2v-90.7c0-10.1,5.9-25.5-2.8-30.5L208.7,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M205.4,141.2c-8.8-5.1-54-12.4-54-2.3v84.1c0,10.1-1.2,37.2,7.6,42.3l71.8,42c8.8,5.1,26.5-8.4,26.5-18.5 v-89.9c0-10.1,5.1-25.2-3.7-30.3L205.4,141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M202.2,140.1c-8.8-5.1-51.3-11.5-51.3-1.5v83.8c0,10.1-0.6,36.1,8.2,41.2l71.6,41.9 c8.8,5.1,25.8-7.8,25.8-17.8v-89.2c0-10.1,4.2-25-4.6-30.1L202.2,140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M198.9,139.1c-8.8-5.1-48.5-10.7-48.5-0.7v83.4c0,10.1,0,35.1,8.8,40.1l71.5,41.9c8.8,5.1,25-7.1,25-17.2 v-88.4c0-10.1,3.3-24.8-5.4-29.9L198.9,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M195.6,138c-8.8-5.1-45.8-9.9-45.8,0.1v83.1c0,10.1,0.6,34,9.3,39.1l71.4,41.8c8.8,5.1,24.2-6.4,24.2-16.5 v-87.6c0-10.1,2.5-24.6-6.3-29.6L195.6,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M192.3,136.9c-8.8-5.1-43.1-9.1-43.1,0.9v82.7c0,10,1.2,32.9,9.9,38l71.2,41.7c8.8,5.1,23.5-5.7,23.5-15.8 v-86.9c0-10,1.6-24.3-7.1-29.4L192.3,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M189.1,135.8c-8.7-5.1-40.3-8.3-40.3,1.7v82.4c0,10,1.8,31.8,10.5,36.9l71.1,41.6 c8.7,5.1,22.7-5.1,22.7-15.1v-86.1c0-10,0.7-24.1-8-29.2L189.1,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M185.8,134.7c-8.7-5-37.6-7.5-37.6,2.5v82c0,10,2.4,30.8,11.1,35.8l71,41.5c8.7,5,21.9-4.4,21.9-14.4 v-85.3c0-10-0.1-23.9-8.9-29L185.8,134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M182.5,133.6c-8.7-5-34.9-6.7-34.9,3.3v81.7c0,10,2.9,29.7,11.7,34.7l70.8,41.5c8.7,5,21.1-3.7,21.1-13.7 v-84.6c0-10-1-23.7-9.7-28.7L182.5,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M179.2,132.5c-8.7-5-32.1-5.9-32.1,4.2V218c0,10,3.5,28.6,12.3,33.6L230,293c8.7,5,20.4-3,20.4-13.1v-83.8 c0-10-1.9-23.5-10.6-28.5L179.2,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M176,131.5c-8.7-5-29.4-5.1-29.4,5v81c0,10,4.1,27.5,12.8,32.6l70.5,41.3c8.7,5,19.6-2.4,19.6-12.4v-83 c0-10-2.7-23.2-11.4-28.3L176,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M172.7,130.4c-8.7-5-26.7-4.2-26.7,5.8v80.6c0,10,4.7,26.5,13.4,31.5l70.4,41.2c8.7,5,18.8-1.7,18.8-11.7 v-82.3c0-10-3.6-23-12.3-28.1L172.7,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M169.4,129.3c-8.7-5-23.9-3.4-23.9,6.6v80.3c0,10,5.3,25.4,14,30.4l70.3,41.1c8.7,5,18.1-1,18.1-11v-81.5 c0-10-4.5-22.8-13.2-27.8L169.4,129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M166.1,128.2c-8.7-5-21.2-2.6-21.2,7.4v79.9c0,10,5.9,24.3,14.6,29.3l70.1,41.1c8.7,5,17.3-0.3,17.3-10.3 v-80.7c0-10-5.3-22.6-14-27.6L166.1,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M162.9,127.1c-8.7-5-18.5-1.8-18.5,8.2v79.6c0,10,6.5,23.2,15.2,28.2l70,41c8.7,5,16.5,0.3,16.5-9.7v-80 c0-10-6.2-22.4-14.9-27.4L162.9,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M159.6,126c-8.7-5-15.7-1-15.7,9v79.2c0,10,7.1,22.1,15.7,27.2l69.9,40.9c8.7,5,15.7,1,15.7-9v-79.2 c0-10-7.1-22.1-15.7-27.2L159.6,126z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088840582353694259340000004372146574209791393_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.1904,
    y1: 272.8303,
    x2: 230.8332,
    y2: 150.4732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01332336,
    style: {
      stopColor: "#D6DBF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04334042,
    style: {
      stopColor: "#E4E8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07070711,
    style: {
      stopColor: "#E8ECFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5325,
    style: {
      stopColor: "#F2F5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F7FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088840582353694259340000004372146574209791393_)"
    },
    d: "M159,108.3c-2.1-2-5.4-2.2-9.1,0 c-6.1,3.5-11,11.9-11.3,18.9c0,0,0,3.3,0,4.1l0,0c0,1.3-0.1,112.4-0.1,112.5c0,5.1-2.6,11.1-6.4,15.3l93.4,53.4 c-0.9,2.3-1.4,4.7-1.4,6.9c0,3.2,1.1,5.5,2.8,6.7l0.2,0.2l-0.6-0.3c0.6,0.5,1.3,0.8,2.1,0.9c0,0,0,0,0,0c0.2,0,0.5,0.1,0.8,0.1 c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0c1.4-0.1,2.9-0.6,4.5-1.5c1.7-1,3.3-2.4,4.8-4c1.8-1.6,3.1-3.7,4-6c1.5-3.1,2.5-6.4,2.5-9.5 c0-0.1,0.1-1.2,0.1-2.6c0-0.7,0-84.2,0-113c0,0,0-0.1,0-0.1c0-1.1,0-1.8,0-1.8c0.3-7,5.2-15.4,11.3-18.9c2.5-1.4,4.8-1.8,6.6-1.3 L159,108.3z"
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "146.9,127.9 146.9,131 217.4,171.2 217.4,168.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "182.1,155.6 146.9,135.4 146.9,138.5 182.1,158.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "185,157.4 185,160.4 238.2,190.7 238.2,187.6  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M183.4,265.1l19.3,11.3v-3.1L183.4,262V265.1z M191.8,262.9l18.9,10.9v-3.1l-18.9-10.9V262.9z M181.2,260.7 l-12.9-7.5v3.1l12.9,7.5V260.7z M189.6,258.5l-21.3-12.6v3.1l21.3,12.6V258.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M163.2,242.1l-14.2-8.6c0,4.5,0,13.4,0,16.3l14.2,8.1V242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M163.2,256.4l-13.6-7.8c0-2.5,0-10.9,0-14.8l-0.6-0.4c0,4.5,0,13.4,0,16.3l14.2,8.1V256.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M183.4,238.8l14,8.3V244l-14-8.3V238.8z M181.2,234.4l-12.9-7.5v3.1l12.9,7.5V234.4z M193.1,234.3 l-24.8-14.6v3.1l24.8,14.6V234.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M163.2,215.8l-14.2-8.6c0,4.5,0,13.4,0,16.3l14.2,8.1V215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M163.2,230.1l-13.6-7.8c0-2.5,0-10.9,0-14.8l-0.6-0.4c0,4.5,0,13.4,0,16.3l14.2,8.1V230.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M151.8,217.2l3.4,7.4l6.3-6.6c0.2-0.2,0.1-0.8-0.3-1.1l-1.9-1.8c-0.3-0.2-0.5-0.3-0.6-0.1l-3.4,5.7 l-1.5-3.5c-0.1-0.3-0.4-0.6-0.6-0.6l-1-0.2C151.7,216.3,151.6,216.7,151.8,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M178.2,208.5l12.9,7.7v-3.1l-12.9-7.7V208.5z M187,206.5l23.7,13.9v-3.1L187,203.4V206.5z M175.9,204.1 l-7.7-4.4v3.1l7.7,4.4V204.1z M184.8,202.1l-16.5-9.6v3.1l16.5,9.6V202.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M163.2,188.6L149,180c0,4.5,0,13.4,0,16.3l14.2,8.1V188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M163.2,202.9l-13.6-7.8c0-2.5,0-10.9,0-14.8L149,180c0,4.5,0,13.4,0,16.3l14.2,8.1V202.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M183.4,184.6l14,8.3v-3.1l-14-8.3V184.6z M181.2,180.1l-12.9-7.5v3.1l12.9,7.5V180.1z M193.1,180.1 l-24.8-14.6v3.1l24.8,14.6V180.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M163.2,161.5l-14.2-8.6c0,4.5,0,13.4,0,16.3l14.2,8.1V161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M163.2,175.9l-13.6-7.8c0-2.5,0-10.9,0-14.8l-0.6-0.4c0,4.5,0,13.4,0,16.3l14.2,8.1V175.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M151.8,162.9l3.4,7.4l6.3-6.6c0.2-0.2,0.1-0.8-0.3-1.1l-1.9-1.8c-0.3-0.2-0.5-0.3-0.6-0.1l-3.4,5.7 l-1.5-3.5c-0.1-0.3-0.4-0.6-0.6-0.6l-1-0.2C151.7,162,151.6,162.4,151.8,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M151.8,189.6l3.4,7.4l6.3-6.6c0.2-0.2,0.1-0.8-0.3-1.1l-1.9-1.8c-0.3-0.2-0.5-0.3-0.6-0.1l-3.4,5.7 l-1.5-3.5c-0.1-0.3-0.4-0.6-0.6-0.6l-1-0.2C151.7,188.7,151.6,189.1,151.8,189.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009557350860485363680000017629888395130197942_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.8991,
    y1: 73.1075,
    x2: 266.8038,
    y2: 40.1879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFB6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    style: {
      stopColor: "#BCC2EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#CACFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED3F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009557350860485363680000017629888395130197942_)"
    },
    d: "M269,70.5c-1.5-5.1-5.1-9.9-9-12.2l-5.2-3 c-1.8-1.1-2.9-4.1-1.7-5.1c2.1-1.7,3.3-4.8,3.2-8.9c-0.2-8.4-6-18.5-13.2-23.2c-8.2-5.3-15-1.8-15,7.5c0,3.9,1.2,8.1,3.2,12.1 c1.2,2.3,0.1,4.1-1.7,3.1l-5.2-3c-4-2.3-7.5-1.6-9,1.8L209.6,52l64.9,37.5L269,70.5z M242.1,39.2c-2.6-1.5-4.8-5.2-4.8-8.2 c0-3,2.1-4.2,4.8-2.7c2.6,1.5,4.8,5.2,4.8,8.2C246.9,39.5,244.7,40.7,242.1,39.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000054228537231273440930000007612617945914677122_",
    cx: 239.7639,
    cy: 34.4591,
    r: 5.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054228537231273440930000007612617945914677122_)"
    },
    d: "M238.1,28.3c-1.5,0.1-2.5,1.3-2.5,3.4 c0,3,2.1,6.7,4.8,8.2c1.4,0.8,2.7,0.8,3.6,0.2c-0.7,0-1.4-0.2-2.3-0.7c-2.6-1.5-4.8-5.2-4.8-8.2C236.9,29.9,237.4,28.9,238.1,28.3 z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165919818196091832770000012334401012316648843_",
    cx: 253.2206,
    cy: 52.8946,
    r: 30.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165919818196091832770000012334401012316648843_)"
    },
    d: "M241.3,18.9c7.2,4.6,12.9,14.8,13.2,23.2 c0.1,4.2-1.1,7.2-3.2,8.9c-1.2,1-0.1,4,1.7,5.1l5.2,3c4,2.3,7.5,7.1,9,12.2l5.2,17.6l1.7,1l-5.6-19c-1.5-5.1-5.1-9.9-9-12.2 l-5.2-3c-1.8-1.1-2.9-4.1-1.7-5.1c2.1-1.7,3.3-4.8,3.2-8.9c-0.2-8.4-6-18.5-13.2-23.2c-3.9-2.6-7.6-3.1-10.3-1.9 C234.8,16,237.9,16.7,241.3,18.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170275658677951956740000004786516058695892611_",
    cx: 223.4066,
    cy: 39.2446,
    r: 4.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170275658677951956740000004786516058695892611_)"
    },
    d: "M222.5,38.5l5.2,3 c0.9,0.5,1.5,0.3,1.9-0.2c-0.2,0-0.4-0.1-0.6-0.3l-5.2-3c-2.5-1.5-4.9-1.7-6.7-0.8C218.7,36.9,220.6,37.3,222.5,38.5z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M238.5,28c-1.5,0.1-2.5,1.3-2.5,3.4c0,3,2.1,6.7,4.8,8.2c1.4,0.8,2.7,0.8,3.6,0.2c-0.7,0-1.4-0.2-2.3-0.7 c-2.6-1.5-4.8-5.2-4.8-8.2C237.3,29.5,237.8,28.5,238.5,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M241.7,18.5c7.2,4.6,12.9,14.8,13.2,23.2c0.1,4.2-1.1,7.2-3.2,8.9c-1.2,1-0.1,4,1.7,5.1l5.2,3 c4,2.3,7.5,7.1,9,12.2l5.2,17.6l1.7,1l-5.6-19c-1.5-5.1-5.1-9.9-9-12.2l-5.2-3c-1.8-1.1-2.9-4.1-1.7-5.1c2.1-1.7,3.3-4.8,3.2-8.9 c-0.2-8.4-6-18.5-13.2-23.2c-3.9-2.6-7.6-3.1-10.3-1.9C235.2,15.7,238.3,16.4,241.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M222.9,38.1l5.2,3c0.9,0.5,1.5,0.3,1.9-0.2c-0.2,0-0.4-0.1-0.6-0.3l-5.2-3c-2.5-1.5-4.9-1.7-6.7-0.8 C219.1,36.6,221,37,222.9,38.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161622211125675600230000012710586899024928139_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.2411,
    y1: 64.1428,
    x2: 242.2213,
    y2: 60.7131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#858DC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319677,
    style: {
      stopColor: "#878FC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    style: {
      stopColor: "#9DA5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#ABB2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFB6E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161622211125675600230000012710586899024928139_)"
    },
    d: "M259.5,75.7l-36.6-21.1 c-1.1-0.6-2-2.3-2-3.8l0,0c0-1.5,0.9-2.1,2-1.5l36.6,21.1c1.1,0.6,2,2.3,2,3.8l0,0C261.4,75.7,260.6,76.4,259.5,75.7z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 95.4,
    y: 200.4,
    width: 48.9,
    height: 59.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 95.4,
    y: 200.4,
    width: 48.9,
    height: 59.7,
    id: "SVGID_00000065774390727114518510000002514293601033667218_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st204"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137838455152332613890000011255186492428598411_",
    gradientUnits: "userSpaceOnUse",
    x1: 661.8269,
    y1: -626.3517,
    x2: 647.1177,
    y2: -589.5787,
    gradientTransform: "matrix(0.9745 -0.2242 0.2242 0.9745 -378.3252 974.012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137838455152332613890000011255186492428598411_)"
    },
    points: "146.5,268.8 81.5,240  100.3,197.6 165.3,226.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_00000065774390727114518510000002514293601033667218_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M144.3,259.7l-2.2,0.2c-4,0.4-9-0.5-11.4-3.7l-35-53.8c-2.4-3.8,10-2.8,14.6,4.6L144.3,259.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M141.7,259.9c-3.7,0.4-8.4-0.6-10.6-3.6l-34.4-53.1c-2.4-3.7,9.2-2.8,13.6,4.2l33.6,52.2 C143.7,259.7,141.7,259.9,141.7,259.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M141.2,259.8c-3.5,0.3-7.8-0.6-9.9-3.5L97.5,204c-2.4-3.7,8.4-2.8,12.5,3.8l33.3,51.9 C143.2,259.7,141.3,259.9,141.2,259.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M140.8,259.8c-3.2,0.2-7.2-0.7-9.2-3.4l-33.3-51.6c-2.4-3.7,7.6-2.8,11.4,3.4l32.9,51.5 C142.6,259.7,140.9,259.8,140.8,259.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M140.3,259.7c-3,0.1-6.6-0.8-8.4-3.3l-32.7-50.9c-2.3-3.7,6.8-2.8,10.4,3l32.6,51.1 C142,259.6,140.5,259.7,140.3,259.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M139.9,259.6c-2.7,0-6-0.9-7.7-3.1l-32.1-50.2c-2.3-3.6,6-2.7,9.3,2.6l32.2,50.8 C141.5,259.6,140.1,259.7,139.9,259.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M139.5,259.5c-2.5-0.1-5.4-1-6.9-3L101,207c-2.3-3.6,5.1-2.7,8.3,2.2l31.9,50.4 C140.9,259.6,139.7,259.6,139.5,259.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M139,259.4c-2.2-0.2-4.8-1.1-6.2-2.9l-31-48.7c-2.3-3.6,4.3-2.7,7.2,1.8l31.5,50 C140.3,259.5,139.3,259.5,139,259.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M138.6,259.4c-2-0.3-4.2-1.2-5.4-2.8l-30.4-48c-2.3-3.6,3.5-2.7,6.1,1.4l31.2,49.7 C139.8,259.5,138.9,259.5,138.6,259.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M138.2,259.3c-1.7-0.4-3.6-1.2-4.7-2.7l-29.8-47.3c-2.3-3.5,2.7-2.7,5.1,1l30.8,49.3 C139.2,259.5,138.5,259.4,138.2,259.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M137.7,259.2c-1.5-0.5-3-1.3-3.9-2.6L104.5,210c-2.2-3.5,1.9-2.7,4,0.6l30.5,48.9 C138.6,259.5,138.1,259.4,137.7,259.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M137.3,259.1c-1.3-0.6-2.3-1.4-3.2-2.5l-28.7-45.8c-2.2-3.5,1.1-2.7,2.9,0.2l30.1,48.6 C138.1,259.4,137.7,259.3,137.3,259.1z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 182.2,
    transform: "matrix(0.8999 -0.4361 0.4361 0.8999 -92.683 76.4214)",
    className: "st74",
    width: 4.2,
    height: 115.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 182,
    transform: "matrix(0.9 -0.436 0.436 0.9 -92.488 76.6584)",
    className: "st76",
    width: 1.5,
    height: 115.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "146.1,291.2 96.1,188.2 95.8,188.3 145.8,291.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "144.2,292.4 94.2,189.3 93.9,189.4 143.9,292.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000165946718774182512910000010713832339473835403_",
    filterUnits: "userSpaceOnUse",
    x: 147.1,
    y: 291.2,
    width: 24.9,
    height: 12.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 147.1,
    y: 291.2,
    width: 24.9,
    height: 12.3,
    id: "SVGID_00000041991935637569373630000005492720870318915500_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000165946718774182512910000010713832339473835403_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145739417027300362520000017702272197108806283_",
    gradientUnits: "userSpaceOnUse",
    x1: 8124.7358,
    y1: 299.4278,
    x2: 8097.4458,
    y2: 275.0552,
    gradientTransform: "matrix(-1 0 0 1 8285.542 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145739417027300362520000017702272197108806283_)"
    },
    points: "143.5,306.6 212.7,306.6  212.7,261.4 143.5,261.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_00000041991935637569373630000005492720870318915500_)"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M147.1,300.2l1.9,1.1c3.4,2,8.2,3.1,11.6,1.2l10.5-5.9c3.6-2.4-4.6-8.4-11.6-3.7L147.1,300.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M149.5,301.3c3.2,1.8,7.7,2.8,10.9,1l10.2-5.8c3.6-2.4-4.1-7.9-10.8-3.4l-12.1,7.2 C147.8,300.3,149.5,301.3,149.5,301.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M150.1,301.4c3,1.6,7.2,2.5,10.2,0.8l10-5.7c3.6-2.4-3.7-7.4-10-3.2l-11.9,7.1 C148.4,300.5,150,301.4,150.1,301.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M150.7,301.4c2.8,1.4,6.7,2.2,9.5,0.6l9.7-5.6c3.6-2.4-3.3-6.9-9.2-2.9l-11.7,7.1 C149.1,300.6,150.6,301.4,150.7,301.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M151.3,301.4c2.6,1.3,6.2,1.9,8.8,0.4l9.4-5.5c3.5-2.3-2.9-6.4-8.4-2.7l-11.5,7 C149.8,300.7,151.2,301.4,151.3,301.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M151.9,301.4c2.4,1.1,5.7,1.6,8.1,0.2l9.1-5.4c3.5-2.3-2.4-5.9-7.6-2.5l-11.2,7 C150.5,300.8,151.7,301.4,151.9,301.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M152.5,301.5c2.3,0.9,5.2,1.2,7.4,0l8.8-5.3c3.5-2.3-2-5.4-6.7-2.2l-11,6.9 C151.2,301,152.3,301.5,152.5,301.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M153.1,301.5c2.1,0.7,4.7,0.9,6.7-0.2l8.6-5.2c3.5-2.3-1.6-4.9-5.9-2l-10.8,6.9 C151.9,301.1,152.9,301.5,153.1,301.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M153.7,301.5c1.9,0.5,4.2,0.6,5.9-0.4l8.3-5.1c3.4-2.3-1.2-4.4-5.1-1.7l-10.5,6.8 C152.6,301.2,153.4,301.5,153.7,301.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M154.3,301.5c1.7,0.4,3.7,0.3,5.2-0.6l8-5c3.4-2.3-0.8-3.9-4.3-1.5l-10.3,6.7 C153.3,301.3,154,301.5,154.3,301.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M154.9,301.6c1.5,0.2,3.2,0,4.5-0.8l7.7-4.9c3.4-2.2-0.3-3.4-3.5-1.2l-10.1,6.7 C154,301.4,154.5,301.6,154.9,301.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M155.5,301.6c1.3,0,2.7-0.3,3.8-1l7.5-4.8c3.3-2.2,0.1-2.9-2.7-1l-9.8,6.6 C154.7,301.6,155.1,301.6,155.5,301.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165193641820256401530000002247682372831811992_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.9333,
    y1: 279.135,
    x2: 169.7867,
    y2: 279.135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4258BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262973"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165193641820256401530000002247682372831811992_)"
    },
    d: "M126,259.7L126,259.7 c-0.3-0.6,0.8-1.6,2.4-2.4c1.6-0.8,3.1-1,3.4-0.4l0,0l0.1,0l16.4,33.9c0.9,1.9,2.5,3.3,4.5,4c2,0.7,4.1,0.6,5.9-0.3 c1.9-0.9,3.3-2.5,4-4.5c0.7-2,0.6-4.1-0.3-5.9l-4.2-8.6l0.1,0l0,0c-0.3-0.5,0.8-1.6,2.5-2.4c1.6-0.8,3.1-1,3.4-0.4l0,0l0,0l4.2,8.6 c3.5,7.2,0.5,15.8-6.7,19.3c-2,1-4.1,1.5-6.3,1.5c-1.6,0-3.2-0.3-4.7-0.8c-3.6-1.3-6.6-3.9-8.3-7.3L126,259.7L126,259.7z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M156.4,299.8c1.8,0,3.6-0.4,5.3-1.1c3.1-1.4,5.5-4,6.7-7.3c1.2-3.4,1-7.2-0.5-10.4l-3.7-7.5 c-0.3-0.6-0.9-1-1.6-1c-0.3,0-0.5,0.1-0.8,0.2c-0.4,0.2-0.8,0.6-0.9,1c-0.2,0.5-0.1,0.9,0.1,1.4l3.7,7.5c1,2.1,1.3,4.5,0.7,6.6 c-0.9,3.3-3.4,5.8-6.7,6.6c-0.7,0.2-1.5,0.3-2.3,0.3c-0.4,0-0.8,0-1.2-0.1c-3.2-0.5-5.8-2.3-7.2-5.2l-16-33.1c-0.3-0.6-0.9-1-1.6-1 c-0.3,0-0.5,0.1-0.8,0.2c-0.9,0.4-1.3,1.5-0.8,2.4l16,33.1c1.5,3.1,4.1,5.4,7.4,6.6C153.6,299.6,155,299.8,156.4,299.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M156.4,298.9c1.7,0,3.4-0.4,4.9-1.1c6.2-2.8,8.7-10.4,5.7-16.5l-3.7-7.5c-0.2-0.5-0.8-0.6-1.2-0.4l0,0 c-0.5,0.2-0.6,0.8-0.4,1.2l3.7,7.5c1.1,2.3,1.4,4.8,0.8,7.3c-0.9,3.6-3.7,6.3-7.3,7.3c-1.3,0.3-2.6,0.4-3.9,0.2 c-3.5-0.5-6.4-2.6-7.9-5.7l-16-33.1c-0.2-0.5-0.8-0.6-1.2-0.4l0,0c-0.5,0.2-0.6,0.8-0.4,1.2l16,33.1c1.4,2.9,3.8,5.1,6.9,6.1 C153.8,298.7,155.1,298.9,156.4,298.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M156.7,298.2c1.6,0,3.2-0.3,4.7-1c2.7-1.2,4.8-3.5,5.9-6.4c1.1-3,0.9-6.4-0.5-9.3l-3.7-7.5 c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.3-0.1,0.4l3.7,7.5c1.2,2.5,1.5,5.2,0.8,7.7c-1,3.8-3.9,6.7-7.7,7.7 c-0.9,0.2-1.8,0.4-2.7,0.4c-0.5,0-1,0-1.4-0.1c-3.7-0.5-6.7-2.7-8.3-6l-16-33.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0-0.1,0 c-0.1,0.1-0.2,0.3-0.1,0.4l16,33.1c1.3,2.7,3.6,4.8,6.5,5.8C154.1,298,155.4,298.2,156.7,298.2z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st226"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M160,275.4l3.7,7.5c0.5,1,0.6,2.6,0.6,4.1c-0.1-1.3-0.5-2.5-1.1-3.7l-3.7-7.5c-0.1-0.1,0-0.3,0.1-0.4 c0,0,0.1,0,0.1,0C159.8,275.3,159.9,275.3,160,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M127.4,259.7c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.2l16,33.1c0.6,1.3,1.4,2.3,2.4,3.3c0.9,1,1.9,1.9,3.1,2.6 c-2.6-1.1-4.8-3-6-5.6l-16-33.1C127.2,259.9,127.2,259.7,127.4,259.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160884096417995231550000008189485005587100842_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.1615,
    y1: 107.704,
    x2: 204.4194,
    y2: 51.6249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160884096417995231550000008189485005587100842_)"
    },
    d: "M191.8,58.9l3,1.8v22.2l-3-1.8V58.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056401295328616159400000013066205292223304592_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.7338,
    y1: 112.6352,
    x2: 212.9918,
    y2: 56.5559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056401295328616159400000013066205292223304592_)"
    },
    d: "M197.1,61.9l3.8,2.2l3,15l0.1,0V65.9 l2.7,1.6v22.2l-3.1-1.8l-3.7-18.3l-0.1,0v16.2l-2.7-1.6V61.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029047952878764200710000011087460313475588228_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8163,
    y1: 119.0099,
    x2: 224.0742,
    y2: 62.9307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029047952878764200710000011087460313475588228_)"
    },
    d: "M209.6,90.2c-0.8-1.4-1.1-3-1.1-4.8v-1.3 l2.9,1.7v1.5c0,1.4,0.5,2.5,1.6,3.1c0.5,0.3,0.9,0.3,1.2,0.2c0.3-0.2,0.4-0.7,0.4-1.5c0-0.9-0.2-1.9-0.6-2.8 c-0.4-0.9-1.1-2.2-2-3.7c-1.3-2-2.1-3.6-2.6-5c-0.5-1.3-0.7-2.6-0.7-3.9c0-1.8,0.4-2.9,1.2-3.4c0.8-0.5,1.9-0.3,3.4,0.5 c1.5,0.8,2.6,2,3.3,3.4c0.7,1.4,1.1,3,1.1,4.8v0.9l-2.9-1.7v-1.1c0-0.8-0.1-1.4-0.4-1.9c-0.3-0.5-0.6-0.9-1.1-1.2 c-1-0.6-1.5-0.2-1.5,1.2c0,0.8,0.2,1.7,0.6,2.6c0.4,0.9,1.1,2.2,2.1,3.7c1.3,2,2.1,3.7,2.6,5c0.5,1.3,0.7,2.7,0.7,4.1 c0,1.8-0.4,3-1.2,3.5c-0.8,0.5-1.9,0.4-3.4-0.5C211.4,92.7,210.3,91.6,209.6,90.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023960375302791382560000008184159992830776448_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.7782,
    y1: 124.7403,
    x2: 234.0361,
    y2: 68.6612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023960375302791382560000008184159992830776448_)"
    },
    d: "M220.3,96.4c-0.8-1.4-1.2-3-1.2-4.8v-17 l3,1.8v17.2c0,0.8,0.1,1.4,0.4,1.9c0.3,0.5,0.7,0.9,1.1,1.2c0.5,0.3,0.9,0.3,1.1,0.2c0.3-0.2,0.4-0.7,0.4-1.4V78.2l2.9,1.7v17 c0,1.8-0.4,3-1.2,3.5c-0.8,0.5-1.9,0.3-3.4-0.5C222.2,99,221.1,97.8,220.3,96.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074431885847249331470000010607316911207277964_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9161,
    y1: 131.7222,
    x2: 246.1741,
    y2: 75.6429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074431885847249331470000010607316911207277964_)"
    },
    d: "M230.4,81.1l4.5,2.6 c1.6,0.9,2.7,2,3.4,3.2c0.7,1.3,1.1,2.7,1.1,4.5v1.4c0,2.3-0.7,3.4-2,3.2v0.1c0.7,0.7,1.3,1.5,1.6,2.5c0.3,1,0.5,2.1,0.5,3.4v3.9 c0,0.6,0,1.2,0.1,1.6c0,0.4,0.1,0.9,0.3,1.3l-3.1-1.8c-0.1-0.4-0.2-0.8-0.2-1.1c0-0.3-0.1-0.9-0.1-1.7V100c0-1-0.1-1.8-0.4-2.4 c-0.3-0.6-0.8-1.1-1.5-1.5l-1.1-0.6v9.5l-3-1.8V81.1z M234.5,93c0.6,0.4,1.1,0.4,1.4,0.3c0.3-0.2,0.5-0.7,0.5-1.5V90 c0-0.8-0.1-1.5-0.4-2c-0.2-0.5-0.6-0.9-1.2-1.2l-1.4-0.8v6.4L234.5,93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176011246314519843610000003477300022750195341_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.3805,
    y1: 138.892,
    x2: 258.6383,
    y2: 82.8128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176011246314519843610000003477300022750195341_)"
    },
    d: "M243.9,88.9l4.1,2.4l3.2,24l-3-1.8 l-0.6-4.7v0.1l-3.5-2l-0.6,4l-2.8-1.6L243.9,88.9z M247.2,105.7l-1.4-11.8l-0.1,0l-1.3,10.2L247.2,105.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159431313653243617980000015280526098943316644_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.2685,
    y1: 144.5798,
    x2: 268.5263,
    y2: 88.5007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159431313653243617980000015280526098943316644_)"
    },
    d: "M252.6,94l3.8,2.2l3,15l0.1,0V97.9 l2.7,1.6v22.2l-3.1-1.8l-3.7-18.3l-0.1,0v16.2l-2.7-1.6V94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014601896571776457740000004719914358829503914_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.6106,
    y1: 151.1041,
    x2: 279.8685,
    y2: 95.0249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014601896571776457740000004719914358829503914_)"
    },
    d: "M265.4,122.5c-0.8-1.4-1.1-3-1.1-4.7 v-11.9c0-1.7,0.4-2.9,1.1-3.4c0.8-0.5,1.9-0.3,3.3,0.5c1.5,0.8,2.6,2,3.3,3.4c0.8,1.4,1.1,3,1.1,4.7v2.3l-2.9-1.7v-2.6 c0-1.4-0.5-2.4-1.5-2.9c-1-0.6-1.5-0.2-1.5,1.2v12.4c0,1.4,0.5,2.3,1.5,2.9c1,0.6,1.5,0.2,1.5-1.2v-3.4l2.9,1.7v3.1 c0,1.7-0.4,2.9-1.1,3.4c-0.8,0.5-1.9,0.3-3.3-0.5C267.3,125,266.2,123.9,265.4,122.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109712668379015240680000003241927919760184981_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.0806,
    y1: 157.1267,
    x2: 290.3384,
    y2: 101.0476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    style: {
      stopColor: "#5B75F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#7370F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#836DF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109712668379015240680000003241927919760184981_)"
    },
    d: "M275,106.9l8.3,4.8v3.2l-5.3-3v5.9 l4.2,2.4v3.2l-4.2-2.4v6.8l5.3,3v3.2l-8.3-4.8V106.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03MedicalInsurance);
export default __webpack_public_path__ + "static/media/03_Medical_insurance.b47546fbdf287770fa0d7b29ef27e1ad.svg";
export { ForwardRef as ReactComponent };